// @generated by protoc-gen-es v1.2.1 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.assessment.apis.proto (package geneo.analysis.school.assessment.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AttemptTypeEnum, BulkJobStatus, CloudUpload, MarkingSchemeEnum, ModeOfConductionEnum } from "@protos/learning_management/lms.db_pb";
import { DifficultyLevelEnum, Question, Resource_ResourceEnum, ResourceCategoryEnum } from "@protos/content_management/content.db_pb";

/**
 * @generated from enum geneo.analysis.school.assessment.apis.PDFGenStatus
 */
export enum PDFGenStatus {
  /**
   * @generated from enum value: PDF_GENERATION_STATUS_UNDEFINED = 0;
   */
  PDF_GENERATION_STATUS_UNDEFINED = 0,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_PENDING = 1;
   */
  PDF_GENERATION_STATUS_PENDING = 1,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_STARTED = 2;
   */
  PDF_GENERATION_STATUS_STARTED = 2,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_IN_PROGRESS = 3;
   */
  PDF_GENERATION_STATUS_IN_PROGRESS = 3,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_FAILED = 4;
   */
  PDF_GENERATION_STATUS_FAILED = 4,

  /**
   * @generated from enum value: PDF_GENERATION_STATUS_COMPLETED = 5;
   */
  PDF_GENERATION_STATUS_COMPLETED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(PDFGenStatus)
proto3.util.setEnumType(PDFGenStatus, "geneo.analysis.school.assessment.apis.PDFGenStatus", [
  { no: 0, name: "PDF_GENERATION_STATUS_UNDEFINED" },
  { no: 1, name: "PDF_GENERATION_STATUS_PENDING" },
  { no: 2, name: "PDF_GENERATION_STATUS_STARTED" },
  { no: 3, name: "PDF_GENERATION_STATUS_IN_PROGRESS" },
  { no: 4, name: "PDF_GENERATION_STATUS_FAILED" },
  { no: 5, name: "PDF_GENERATION_STATUS_COMPLETED" },
]);

/**
 * @generated from enum geneo.analysis.school.assessment.apis.KdtAssessmentStatus
 */
export enum KdtAssessmentStatus {
  /**
   * @generated from enum value: KDT_ASSESSMENT_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: KDT_ASSESSMENT_STATUS_APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: KDT_ASSESSMENT_STATUS_REJECTED = 2;
   */
  REJECTED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(KdtAssessmentStatus)
proto3.util.setEnumType(KdtAssessmentStatus, "geneo.analysis.school.assessment.apis.KdtAssessmentStatus", [
  { no: 0, name: "KDT_ASSESSMENT_STATUS_UNDEFINED" },
  { no: 1, name: "KDT_ASSESSMENT_STATUS_APPROVED" },
  { no: 2, name: "KDT_ASSESSMENT_STATUS_REJECTED" },
]);

/**
 * @generated from enum geneo.analysis.school.assessment.apis.BloomLevel
 */
export enum BloomLevel {
  /**
   * Retention level
   *
   * @generated from enum value: RETENTION = 0;
   */
  RETENTION = 0,

  /**
   * Comprehension level
   *
   * @generated from enum value: COMPREHENSION = 1;
   */
  COMPREHENSION = 1,

  /**
   * Application level
   *
   * @generated from enum value: APPLICATION = 2;
   */
  APPLICATION = 2,

  /**
   * Analysis level
   *
   * @generated from enum value: ANALYSIS = 3;
   */
  ANALYSIS = 3,

  /**
   * Evaluation level
   *
   * @generated from enum value: EVALUATION = 4;
   */
  EVALUATION = 4,

  /**
   * Creation level
   *
   * @generated from enum value: CREATION = 5;
   */
  CREATION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(BloomLevel)
proto3.util.setEnumType(BloomLevel, "geneo.analysis.school.assessment.apis.BloomLevel", [
  { no: 0, name: "RETENTION" },
  { no: 1, name: "COMPREHENSION" },
  { no: 2, name: "APPLICATION" },
  { no: 3, name: "ANALYSIS" },
  { no: 4, name: "EVALUATION" },
  { no: 5, name: "CREATION" },
]);

/**
 * @generated from enum geneo.analysis.school.assessment.apis.AnswerStatusEnum
 */
export enum AnswerStatusEnum {
  /**
   * @generated from enum value: ANSWER_UNDEFINED = 0;
   */
  ANSWER_UNDEFINED = 0,

  /**
   * @generated from enum value: CORRECT = 1;
   */
  CORRECT = 1,

  /**
   * @generated from enum value: WRONG = 2;
   */
  WRONG = 2,

  /**
   * @generated from enum value: PARTIALLY_CORRECT = 3;
   */
  PARTIALLY_CORRECT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(AnswerStatusEnum)
proto3.util.setEnumType(AnswerStatusEnum, "geneo.analysis.school.assessment.apis.AnswerStatusEnum", [
  { no: 0, name: "ANSWER_UNDEFINED" },
  { no: 1, name: "CORRECT" },
  { no: 2, name: "WRONG" },
  { no: 3, name: "PARTIALLY_CORRECT" },
]);

/**
 * @generated from message geneo.analysis.school.assessment.apis.fetchKdtAssessmentStudentsDetailsRequest
 */
export class fetchKdtAssessmentStudentsDetailsRequest extends Message<fetchKdtAssessmentStudentsDetailsRequest> {
  /**
   * ID for the teacher
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  constructor(data?: PartialMessage<fetchKdtAssessmentStudentsDetailsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.fetchKdtAssessmentStudentsDetailsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): fetchKdtAssessmentStudentsDetailsRequest {
    return new fetchKdtAssessmentStudentsDetailsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): fetchKdtAssessmentStudentsDetailsRequest {
    return new fetchKdtAssessmentStudentsDetailsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): fetchKdtAssessmentStudentsDetailsRequest {
    return new fetchKdtAssessmentStudentsDetailsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: fetchKdtAssessmentStudentsDetailsRequest | PlainMessage<fetchKdtAssessmentStudentsDetailsRequest> | undefined, b: fetchKdtAssessmentStudentsDetailsRequest | PlainMessage<fetchKdtAssessmentStudentsDetailsRequest> | undefined): boolean {
    return proto3.util.equals(fetchKdtAssessmentStudentsDetailsRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.fetchKdtAssessmentStudentsDetailsResponse
 */
export class fetchKdtAssessmentStudentsDetailsResponse extends Message<fetchKdtAssessmentStudentsDetailsResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.KdtAssessmentStudentDetails data = 4;
   */
  data: KdtAssessmentStudentDetails[] = [];

  constructor(data?: PartialMessage<fetchKdtAssessmentStudentsDetailsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.fetchKdtAssessmentStudentsDetailsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: KdtAssessmentStudentDetails, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): fetchKdtAssessmentStudentsDetailsResponse {
    return new fetchKdtAssessmentStudentsDetailsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): fetchKdtAssessmentStudentsDetailsResponse {
    return new fetchKdtAssessmentStudentsDetailsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): fetchKdtAssessmentStudentsDetailsResponse {
    return new fetchKdtAssessmentStudentsDetailsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: fetchKdtAssessmentStudentsDetailsResponse | PlainMessage<fetchKdtAssessmentStudentsDetailsResponse> | undefined, b: fetchKdtAssessmentStudentsDetailsResponse | PlainMessage<fetchKdtAssessmentStudentsDetailsResponse> | undefined): boolean {
    return proto3.util.equals(fetchKdtAssessmentStudentsDetailsResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.KdtAssessmentStudentDetails
 */
export class KdtAssessmentStudentDetails extends Message<KdtAssessmentStudentDetails> {
  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * Name of the student
   *
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * @generated from field: optional string section = 4;
   */
  section?: string;

  /**
   * @generated from field: optional string subject = 5;
   */
  subject?: string;

  /**
   * KdtAssessmentStatus status = 6;
   *
   * @generated from field: google.protobuf.Timestamp completion_date = 7;
   */
  completionDate?: Timestamp;

  /**
   * @generated from field: optional string gcp_report_url = 8;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: optional int64 student_kdt_report_id = 9;
   */
  studentKdtReportId?: bigint;

  constructor(data?: PartialMessage<KdtAssessmentStudentDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.KdtAssessmentStudentDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "completion_date", kind: "message", T: Timestamp },
    { no: 8, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "student_kdt_report_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KdtAssessmentStudentDetails {
    return new KdtAssessmentStudentDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KdtAssessmentStudentDetails {
    return new KdtAssessmentStudentDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KdtAssessmentStudentDetails {
    return new KdtAssessmentStudentDetails().fromJsonString(jsonString, options);
  }

  static equals(a: KdtAssessmentStudentDetails | PlainMessage<KdtAssessmentStudentDetails> | undefined, b: KdtAssessmentStudentDetails | PlainMessage<KdtAssessmentStudentDetails> | undefined): boolean {
    return proto3.util.equals(KdtAssessmentStudentDetails, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.KdtAssessmentSendMailRequest
 */
export class KdtAssessmentSendMailRequest extends Message<KdtAssessmentSendMailRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  /**
   * @generated from field: optional int64 kdt_report_id = 3;
   */
  kdtReportId?: bigint;

  constructor(data?: PartialMessage<KdtAssessmentSendMailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.KdtAssessmentSendMailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kdt_report_id", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KdtAssessmentSendMailRequest {
    return new KdtAssessmentSendMailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KdtAssessmentSendMailRequest {
    return new KdtAssessmentSendMailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KdtAssessmentSendMailRequest {
    return new KdtAssessmentSendMailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: KdtAssessmentSendMailRequest | PlainMessage<KdtAssessmentSendMailRequest> | undefined, b: KdtAssessmentSendMailRequest | PlainMessage<KdtAssessmentSendMailRequest> | undefined): boolean {
    return proto3.util.equals(KdtAssessmentSendMailRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.KdtAssessmentSendMailResponse
 */
export class KdtAssessmentSendMailResponse extends Message<KdtAssessmentSendMailResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<KdtAssessmentSendMailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.KdtAssessmentSendMailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KdtAssessmentSendMailResponse {
    return new KdtAssessmentSendMailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KdtAssessmentSendMailResponse {
    return new KdtAssessmentSendMailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KdtAssessmentSendMailResponse {
    return new KdtAssessmentSendMailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: KdtAssessmentSendMailResponse | PlainMessage<KdtAssessmentSendMailResponse> | undefined, b: KdtAssessmentSendMailResponse | PlainMessage<KdtAssessmentSendMailResponse> | undefined): boolean {
    return proto3.util.equals(KdtAssessmentSendMailResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfRequest
 */
export class updateStudentAssessmentReportPdfRequest extends Message<updateStudentAssessmentReportPdfRequest> {
  /**
   * @generated from field: int64 homeworkId = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: int64 studentId = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string gcpReportUrl = 3;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 4;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  constructor(data?: PartialMessage<updateStudentAssessmentReportPdfRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homeworkId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "studentId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "gcpReportUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentReportPdfRequest {
    return new updateStudentAssessmentReportPdfRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfRequest {
    return new updateStudentAssessmentReportPdfRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfRequest {
    return new updateStudentAssessmentReportPdfRequest().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentReportPdfRequest | PlainMessage<updateStudentAssessmentReportPdfRequest> | undefined, b: updateStudentAssessmentReportPdfRequest | PlainMessage<updateStudentAssessmentReportPdfRequest> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentReportPdfRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfResponse
 */
export class updateStudentAssessmentReportPdfResponse extends Message<updateStudentAssessmentReportPdfResponse> {
  constructor(data?: PartialMessage<updateStudentAssessmentReportPdfResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentReportPdfResponse {
    return new updateStudentAssessmentReportPdfResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfResponse {
    return new updateStudentAssessmentReportPdfResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfResponse {
    return new updateStudentAssessmentReportPdfResponse().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentReportPdfResponse | PlainMessage<updateStudentAssessmentReportPdfResponse> | undefined, b: updateStudentAssessmentReportPdfResponse | PlainMessage<updateStudentAssessmentReportPdfResponse> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentReportPdfResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentSummaryReportPdfRequest
 */
export class updateStudentAssessmentSummaryReportPdfRequest extends Message<updateStudentAssessmentSummaryReportPdfRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string gcp_summary_report_url = 3;
   */
  gcpSummaryReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 4;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional int32 attempt_number = 5;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 6;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<updateStudentAssessmentSummaryReportPdfRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentSummaryReportPdfRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "gcp_summary_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 5, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentSummaryReportPdfRequest {
    return new updateStudentAssessmentSummaryReportPdfRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentSummaryReportPdfRequest {
    return new updateStudentAssessmentSummaryReportPdfRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentSummaryReportPdfRequest {
    return new updateStudentAssessmentSummaryReportPdfRequest().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentSummaryReportPdfRequest | PlainMessage<updateStudentAssessmentSummaryReportPdfRequest> | undefined, b: updateStudentAssessmentSummaryReportPdfRequest | PlainMessage<updateStudentAssessmentSummaryReportPdfRequest> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentSummaryReportPdfRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentSummaryReportPdfResponse
 */
export class updateStudentAssessmentSummaryReportPdfResponse extends Message<updateStudentAssessmentSummaryReportPdfResponse> {
  constructor(data?: PartialMessage<updateStudentAssessmentSummaryReportPdfResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentSummaryReportPdfResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentSummaryReportPdfResponse {
    return new updateStudentAssessmentSummaryReportPdfResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentSummaryReportPdfResponse {
    return new updateStudentAssessmentSummaryReportPdfResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentSummaryReportPdfResponse {
    return new updateStudentAssessmentSummaryReportPdfResponse().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentSummaryReportPdfResponse | PlainMessage<updateStudentAssessmentSummaryReportPdfResponse> | undefined, b: updateStudentAssessmentSummaryReportPdfResponse | PlainMessage<updateStudentAssessmentSummaryReportPdfResponse> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentSummaryReportPdfResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfV2Request
 */
export class updateStudentAssessmentReportPdfV2Request extends Message<updateStudentAssessmentReportPdfV2Request> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string gcp_report_url = 3;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 4;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional int32 attempt_number = 5;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 6;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<updateStudentAssessmentReportPdfV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 5, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentReportPdfV2Request {
    return new updateStudentAssessmentReportPdfV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfV2Request {
    return new updateStudentAssessmentReportPdfV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfV2Request {
    return new updateStudentAssessmentReportPdfV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentReportPdfV2Request | PlainMessage<updateStudentAssessmentReportPdfV2Request> | undefined, b: updateStudentAssessmentReportPdfV2Request | PlainMessage<updateStudentAssessmentReportPdfV2Request> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentReportPdfV2Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfV2Response
 */
export class updateStudentAssessmentReportPdfV2Response extends Message<updateStudentAssessmentReportPdfV2Response> {
  constructor(data?: PartialMessage<updateStudentAssessmentReportPdfV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentAssessmentReportPdfV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentAssessmentReportPdfV2Response {
    return new updateStudentAssessmentReportPdfV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfV2Response {
    return new updateStudentAssessmentReportPdfV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentAssessmentReportPdfV2Response {
    return new updateStudentAssessmentReportPdfV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentAssessmentReportPdfV2Response | PlainMessage<updateStudentAssessmentReportPdfV2Response> | undefined, b: updateStudentAssessmentReportPdfV2Response | PlainMessage<updateStudentAssessmentReportPdfV2Response> | undefined): boolean {
    return proto3.util.equals(updateStudentAssessmentReportPdfV2Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateAssessmentReportPDFRequest
 */
export class updateAssessmentReportPDFRequest extends Message<updateAssessmentReportPDFRequest> {
  /**
   * @generated from field: int64 homeworkId = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: string gcpReportUrl = 2;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional int32 attempt_number = 4;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 5;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<updateAssessmentReportPDFRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateAssessmentReportPDFRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homeworkId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "gcpReportUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 4, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateAssessmentReportPDFRequest {
    return new updateAssessmentReportPDFRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFRequest {
    return new updateAssessmentReportPDFRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFRequest {
    return new updateAssessmentReportPDFRequest().fromJsonString(jsonString, options);
  }

  static equals(a: updateAssessmentReportPDFRequest | PlainMessage<updateAssessmentReportPDFRequest> | undefined, b: updateAssessmentReportPDFRequest | PlainMessage<updateAssessmentReportPDFRequest> | undefined): boolean {
    return proto3.util.equals(updateAssessmentReportPDFRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateAssessmentReportPDFResponse
 */
export class updateAssessmentReportPDFResponse extends Message<updateAssessmentReportPDFResponse> {
  constructor(data?: PartialMessage<updateAssessmentReportPDFResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateAssessmentReportPDFResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateAssessmentReportPDFResponse {
    return new updateAssessmentReportPDFResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFResponse {
    return new updateAssessmentReportPDFResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFResponse {
    return new updateAssessmentReportPDFResponse().fromJsonString(jsonString, options);
  }

  static equals(a: updateAssessmentReportPDFResponse | PlainMessage<updateAssessmentReportPDFResponse> | undefined, b: updateAssessmentReportPDFResponse | PlainMessage<updateAssessmentReportPDFResponse> | undefined): boolean {
    return proto3.util.equals(updateAssessmentReportPDFResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateAssessmentReportPDFV2Request
 */
export class updateAssessmentReportPDFV2Request extends Message<updateAssessmentReportPDFV2Request> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string gcp_report_url = 2;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * @generated from field: optional int32 attempt_number = 4;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 5;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<updateAssessmentReportPDFV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateAssessmentReportPDFV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 4, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateAssessmentReportPDFV2Request {
    return new updateAssessmentReportPDFV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFV2Request {
    return new updateAssessmentReportPDFV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFV2Request {
    return new updateAssessmentReportPDFV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: updateAssessmentReportPDFV2Request | PlainMessage<updateAssessmentReportPDFV2Request> | undefined, b: updateAssessmentReportPDFV2Request | PlainMessage<updateAssessmentReportPDFV2Request> | undefined): boolean {
    return proto3.util.equals(updateAssessmentReportPDFV2Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateAssessmentReportPDFV2Response
 */
export class updateAssessmentReportPDFV2Response extends Message<updateAssessmentReportPDFV2Response> {
  constructor(data?: PartialMessage<updateAssessmentReportPDFV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateAssessmentReportPDFV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateAssessmentReportPDFV2Response {
    return new updateAssessmentReportPDFV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFV2Response {
    return new updateAssessmentReportPDFV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateAssessmentReportPDFV2Response {
    return new updateAssessmentReportPDFV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: updateAssessmentReportPDFV2Response | PlainMessage<updateAssessmentReportPDFV2Response> | undefined, b: updateAssessmentReportPDFV2Response | PlainMessage<updateAssessmentReportPDFV2Response> | undefined): boolean {
    return proto3.util.equals(updateAssessmentReportPDFV2Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateKdtStudentAssessmentReportPdfRequest
 */
export class updateKdtStudentAssessmentReportPdfRequest extends Message<updateKdtStudentAssessmentReportPdfRequest> {
  /**
   * @generated from field: repeated int64 homeworkIds = 1;
   */
  homeworkIds: bigint[] = [];

  /**
   * @generated from field: string gcpReportUrl = 2;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * ID for the studentId
   *
   * @generated from field: int64 studentId = 4;
   */
  studentId = protoInt64.zero;

  constructor(data?: PartialMessage<updateKdtStudentAssessmentReportPdfRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateKdtStudentAssessmentReportPdfRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homeworkIds", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 2, name: "gcpReportUrl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 4, name: "studentId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateKdtStudentAssessmentReportPdfRequest {
    return new updateKdtStudentAssessmentReportPdfRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateKdtStudentAssessmentReportPdfRequest {
    return new updateKdtStudentAssessmentReportPdfRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateKdtStudentAssessmentReportPdfRequest {
    return new updateKdtStudentAssessmentReportPdfRequest().fromJsonString(jsonString, options);
  }

  static equals(a: updateKdtStudentAssessmentReportPdfRequest | PlainMessage<updateKdtStudentAssessmentReportPdfRequest> | undefined, b: updateKdtStudentAssessmentReportPdfRequest | PlainMessage<updateKdtStudentAssessmentReportPdfRequest> | undefined): boolean {
    return proto3.util.equals(updateKdtStudentAssessmentReportPdfRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateKdtStudentAssessmentReportPdfResponse
 */
export class updateKdtStudentAssessmentReportPdfResponse extends Message<updateKdtStudentAssessmentReportPdfResponse> {
  constructor(data?: PartialMessage<updateKdtStudentAssessmentReportPdfResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateKdtStudentAssessmentReportPdfResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateKdtStudentAssessmentReportPdfResponse {
    return new updateKdtStudentAssessmentReportPdfResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateKdtStudentAssessmentReportPdfResponse {
    return new updateKdtStudentAssessmentReportPdfResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateKdtStudentAssessmentReportPdfResponse {
    return new updateKdtStudentAssessmentReportPdfResponse().fromJsonString(jsonString, options);
  }

  static equals(a: updateKdtStudentAssessmentReportPdfResponse | PlainMessage<updateKdtStudentAssessmentReportPdfResponse> | undefined, b: updateKdtStudentAssessmentReportPdfResponse | PlainMessage<updateKdtStudentAssessmentReportPdfResponse> | undefined): boolean {
    return proto3.util.equals(updateKdtStudentAssessmentReportPdfResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchAssessmentReportRequest
 */
export class FetchAssessmentReportRequest extends Message<FetchAssessmentReportRequest> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 homework_id = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * ID for the teacher
   *
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  constructor(data?: PartialMessage<FetchAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAssessmentReportRequest {
    return new FetchAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAssessmentReportRequest {
    return new FetchAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAssessmentReportRequest {
    return new FetchAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAssessmentReportRequest | PlainMessage<FetchAssessmentReportRequest> | undefined, b: FetchAssessmentReportRequest | PlainMessage<FetchAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchConnectedClassroomAssessmentReportRequest
 */
export class FetchConnectedClassroomAssessmentReportRequest extends Message<FetchConnectedClassroomAssessmentReportRequest> {
  /**
   * ID for the connected class session
   *
   * @generated from field: int64 connected_class_session_id = 1;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * ID for the teacher
   *
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  constructor(data?: PartialMessage<FetchConnectedClassroomAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchConnectedClassroomAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchConnectedClassroomAssessmentReportRequest {
    return new FetchConnectedClassroomAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchConnectedClassroomAssessmentReportRequest {
    return new FetchConnectedClassroomAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchConnectedClassroomAssessmentReportRequest {
    return new FetchConnectedClassroomAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchConnectedClassroomAssessmentReportRequest | PlainMessage<FetchConnectedClassroomAssessmentReportRequest> | undefined, b: FetchConnectedClassroomAssessmentReportRequest | PlainMessage<FetchConnectedClassroomAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchConnectedClassroomAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchAssessmentReportResponse
 */
export class FetchAssessmentReportResponse extends Message<FetchAssessmentReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.AssessmentReport data = 4;
   */
  data?: AssessmentReport;

  constructor(data?: PartialMessage<FetchAssessmentReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchAssessmentReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AssessmentReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAssessmentReportResponse {
    return new FetchAssessmentReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAssessmentReportResponse {
    return new FetchAssessmentReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAssessmentReportResponse {
    return new FetchAssessmentReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAssessmentReportResponse | PlainMessage<FetchAssessmentReportResponse> | undefined, b: FetchAssessmentReportResponse | PlainMessage<FetchAssessmentReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchAssessmentReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchAssessmentReportV2Request
 */
export class FetchAssessmentReportV2Request extends Message<FetchAssessmentReportV2Request> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID for the teacher
   *
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchAssessmentReportV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchAssessmentReportV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAssessmentReportV2Request {
    return new FetchAssessmentReportV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAssessmentReportV2Request {
    return new FetchAssessmentReportV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAssessmentReportV2Request {
    return new FetchAssessmentReportV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAssessmentReportV2Request | PlainMessage<FetchAssessmentReportV2Request> | undefined, b: FetchAssessmentReportV2Request | PlainMessage<FetchAssessmentReportV2Request> | undefined): boolean {
    return proto3.util.equals(FetchAssessmentReportV2Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchAssessmentReportV2Response
 */
export class FetchAssessmentReportV2Response extends Message<FetchAssessmentReportV2Response> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.AssessmentReportV2Data data = 4;
   */
  data?: AssessmentReportV2Data;

  constructor(data?: PartialMessage<FetchAssessmentReportV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchAssessmentReportV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AssessmentReportV2Data },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAssessmentReportV2Response {
    return new FetchAssessmentReportV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAssessmentReportV2Response {
    return new FetchAssessmentReportV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAssessmentReportV2Response {
    return new FetchAssessmentReportV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAssessmentReportV2Response | PlainMessage<FetchAssessmentReportV2Response> | undefined, b: FetchAssessmentReportV2Response | PlainMessage<FetchAssessmentReportV2Response> | undefined): boolean {
    return proto3.util.equals(FetchAssessmentReportV2Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchOmrAssessmentReportV2Response
 */
export class FetchOmrAssessmentReportV2Response extends Message<FetchOmrAssessmentReportV2Response> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.AssessmentReportV3Data data = 4;
   */
  data?: AssessmentReportV3Data;

  constructor(data?: PartialMessage<FetchOmrAssessmentReportV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchOmrAssessmentReportV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AssessmentReportV3Data, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchOmrAssessmentReportV2Response {
    return new FetchOmrAssessmentReportV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchOmrAssessmentReportV2Response {
    return new FetchOmrAssessmentReportV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchOmrAssessmentReportV2Response {
    return new FetchOmrAssessmentReportV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchOmrAssessmentReportV2Response | PlainMessage<FetchOmrAssessmentReportV2Response> | undefined, b: FetchOmrAssessmentReportV2Response | PlainMessage<FetchOmrAssessmentReportV2Response> | undefined): boolean {
    return proto3.util.equals(FetchOmrAssessmentReportV2Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.AssessmentReportV3Data
 */
export class AssessmentReportV3Data extends Message<AssessmentReportV3Data> {
  /**
   * @generated from field: optional string gcp_report_url = 1;
   */
  gcpReportUrl?: string;

  constructor(data?: PartialMessage<AssessmentReportV3Data>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.AssessmentReportV3Data";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentReportV3Data {
    return new AssessmentReportV3Data().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentReportV3Data {
    return new AssessmentReportV3Data().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentReportV3Data {
    return new AssessmentReportV3Data().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentReportV3Data | PlainMessage<AssessmentReportV3Data> | undefined, b: AssessmentReportV3Data | PlainMessage<AssessmentReportV3Data> | undefined): boolean {
    return proto3.util.equals(AssessmentReportV3Data, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.AssessmentReportV2Data
 */
export class AssessmentReportV2Data extends Message<AssessmentReportV2Data> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * Subject name
   *
   * @generated from field: string subject = 5;
   */
  subject = "";

  /**
   * Chapter name
   *
   * @generated from field: repeated string chapters = 6;
   */
  chapters: string[] = [];

  /**
   * Overview of the test
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.TestOverview test_overview = 7;
   */
  testOverview?: TestOverview;

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionPerformance question_performances = 8;
   */
  questionPerformances: QuestionPerformance[] = [];

  /**
   * Performance of students
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentPerformance student_performances = 9;
   */
  studentPerformances: StudentPerformance[] = [];

  /**
   * Achievement of learning outcomes
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.LearningOutcomeAchievement learning_outcome_achievement = 10;
   */
  learningOutcomeAchievement?: LearningOutcomeAchievement;

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedy common_mistakes_remedy = 11;
   */
  commonMistakesRemedy: CommonMistakeAndRemedy[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ChapterWiseOverview chapter_wise_overview = 12;
   */
  chapterWiseOverview: ChapterWiseOverview[] = [];

  /**
   * @generated from field: optional string gcp_report_url = 13;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional string school_white_label_image_url = 15;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 16;
   */
  schoolId?: number;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 17;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 attempt_number = 18;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 19;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 20;
   */
  markingSchemeType?: MarkingSchemeEnum;

  /**
   * Per-subject reports (supports V3 multisubject teacher report).
   * Backwards compatible: consumers that don't expect this field will ignore it.
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectReport subjects = 21;
   */
  subjects: SubjectReport[] = [];

  /**
   * V3 additional fields
   *
   * Unique report identifier
   *
   * @generated from field: optional string report_id = 22;
   */
  reportId?: string;

  /**
   * Type of assessment (e.g., "Knowledge Diagnostic Assessment")
   *
   * @generated from field: optional string assessment_type = 23;
   */
  assessmentType?: string;

  /**
   * ISO timestamp when report was generated
   *
   * @generated from field: optional string generated_on = 24;
   */
  generatedOn?: string;

  /**
   * Student name (for student reports)
   *
   * @generated from field: optional string student_name = 25;
   */
  studentName?: string;

  /**
   * Focus groups for LOs where students struggle
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.FocusGroupAndRemedy focus_group_and_remedy = 26;
   */
  focusGroupAndRemedy: FocusGroupAndRemedy[] = [];

  /**
   * Multi-subject section/subject names (V3)
   *
   * @generated from field: repeated string subject_names = 27;
   */
  subjectNames: string[] = [];

  constructor(data?: PartialMessage<AssessmentReportV2Data>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.AssessmentReportV2Data";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "test_overview", kind: "message", T: TestOverview, opt: true },
    { no: 8, name: "question_performances", kind: "message", T: QuestionPerformance, repeated: true },
    { no: 9, name: "student_performances", kind: "message", T: StudentPerformance, repeated: true },
    { no: 10, name: "learning_outcome_achievement", kind: "message", T: LearningOutcomeAchievement, opt: true },
    { no: 11, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedy, repeated: true },
    { no: 12, name: "chapter_wise_overview", kind: "message", T: ChapterWiseOverview, repeated: true },
    { no: 13, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "created_on", kind: "message", T: Timestamp },
    { no: 15, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 18, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 19, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 20, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
    { no: 21, name: "subjects", kind: "message", T: SubjectReport, repeated: true },
    { no: 22, name: "report_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 23, name: "assessment_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 24, name: "generated_on", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 25, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 26, name: "focus_group_and_remedy", kind: "message", T: FocusGroupAndRemedy, repeated: true },
    { no: 27, name: "subject_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentReportV2Data {
    return new AssessmentReportV2Data().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentReportV2Data {
    return new AssessmentReportV2Data().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentReportV2Data {
    return new AssessmentReportV2Data().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentReportV2Data | PlainMessage<AssessmentReportV2Data> | undefined, b: AssessmentReportV2Data | PlainMessage<AssessmentReportV2Data> | undefined): boolean {
    return proto3.util.equals(AssessmentReportV2Data, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchConnectedClassroomAssessmentReportResponse
 */
export class FetchConnectedClassroomAssessmentReportResponse extends Message<FetchConnectedClassroomAssessmentReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.ConnectedClassroomAssessmentReport data = 4;
   */
  data?: ConnectedClassroomAssessmentReport;

  constructor(data?: PartialMessage<FetchConnectedClassroomAssessmentReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchConnectedClassroomAssessmentReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ConnectedClassroomAssessmentReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchConnectedClassroomAssessmentReportResponse {
    return new FetchConnectedClassroomAssessmentReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchConnectedClassroomAssessmentReportResponse {
    return new FetchConnectedClassroomAssessmentReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchConnectedClassroomAssessmentReportResponse {
    return new FetchConnectedClassroomAssessmentReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchConnectedClassroomAssessmentReportResponse | PlainMessage<FetchConnectedClassroomAssessmentReportResponse> | undefined, b: FetchConnectedClassroomAssessmentReportResponse | PlainMessage<FetchConnectedClassroomAssessmentReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchConnectedClassroomAssessmentReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ConnectedClassroomAssessmentReport
 */
export class ConnectedClassroomAssessmentReport extends Message<ConnectedClassroomAssessmentReport> {
  /**
   * ID for the connected class session
   *
   * @generated from field: int64 connected_class_session_id = 1;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * Subject name
   *
   * @generated from field: string subject = 5;
   */
  subject = "";

  /**
   * Chapter name
   *
   * @generated from field: repeated string chapters = 6;
   */
  chapters: string[] = [];

  /**
   * Overview of the test
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.TestOverview test_overview = 7;
   */
  testOverview?: TestOverview;

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionPerformance question_performances = 8;
   */
  questionPerformances: QuestionPerformance[] = [];

  /**
   * Performance of students
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentPerformance student_performances = 9;
   */
  studentPerformances: StudentPerformance[] = [];

  /**
   * Achievement of learning outcomes
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.LearningOutcomeAchievement learning_outcome_achievement = 10;
   */
  learningOutcomeAchievement?: LearningOutcomeAchievement;

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedy common_mistakes_remedy = 11;
   */
  commonMistakesRemedy: CommonMistakeAndRemedy[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ChapterWiseOverview chapter_wise_overview = 12;
   */
  chapterWiseOverview: ChapterWiseOverview[] = [];

  /**
   * @generated from field: optional string gcp_report_url = 13;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  constructor(data?: PartialMessage<ConnectedClassroomAssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ConnectedClassroomAssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "test_overview", kind: "message", T: TestOverview, opt: true },
    { no: 8, name: "question_performances", kind: "message", T: QuestionPerformance, repeated: true },
    { no: 9, name: "student_performances", kind: "message", T: StudentPerformance, repeated: true },
    { no: 10, name: "learning_outcome_achievement", kind: "message", T: LearningOutcomeAchievement, opt: true },
    { no: 11, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedy, repeated: true },
    { no: 12, name: "chapter_wise_overview", kind: "message", T: ChapterWiseOverview, repeated: true },
    { no: 13, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "created_on", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConnectedClassroomAssessmentReport {
    return new ConnectedClassroomAssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConnectedClassroomAssessmentReport {
    return new ConnectedClassroomAssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConnectedClassroomAssessmentReport {
    return new ConnectedClassroomAssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: ConnectedClassroomAssessmentReport | PlainMessage<ConnectedClassroomAssessmentReport> | undefined, b: ConnectedClassroomAssessmentReport | PlainMessage<ConnectedClassroomAssessmentReport> | undefined): boolean {
    return proto3.util.equals(ConnectedClassroomAssessmentReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.UpdateConnectedClassroomReportPDFRequest
 */
export class UpdateConnectedClassroomReportPDFRequest extends Message<UpdateConnectedClassroomReportPDFRequest> {
  /**
   * @generated from field: int64 connected_class_session_id = 1;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * @generated from field: string gc_report_url = 2;
   */
  gcReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  constructor(data?: PartialMessage<UpdateConnectedClassroomReportPDFRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.UpdateConnectedClassroomReportPDFRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "gc_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateConnectedClassroomReportPDFRequest {
    return new UpdateConnectedClassroomReportPDFRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateConnectedClassroomReportPDFRequest {
    return new UpdateConnectedClassroomReportPDFRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateConnectedClassroomReportPDFRequest {
    return new UpdateConnectedClassroomReportPDFRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateConnectedClassroomReportPDFRequest | PlainMessage<UpdateConnectedClassroomReportPDFRequest> | undefined, b: UpdateConnectedClassroomReportPDFRequest | PlainMessage<UpdateConnectedClassroomReportPDFRequest> | undefined): boolean {
    return proto3.util.equals(UpdateConnectedClassroomReportPDFRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.UpdateConnectedClassroomReportPdfResponse
 */
export class UpdateConnectedClassroomReportPdfResponse extends Message<UpdateConnectedClassroomReportPdfResponse> {
  constructor(data?: PartialMessage<UpdateConnectedClassroomReportPdfResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.UpdateConnectedClassroomReportPdfResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateConnectedClassroomReportPdfResponse {
    return new UpdateConnectedClassroomReportPdfResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateConnectedClassroomReportPdfResponse {
    return new UpdateConnectedClassroomReportPdfResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateConnectedClassroomReportPdfResponse {
    return new UpdateConnectedClassroomReportPdfResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateConnectedClassroomReportPdfResponse | PlainMessage<UpdateConnectedClassroomReportPdfResponse> | undefined, b: UpdateConnectedClassroomReportPdfResponse | PlainMessage<UpdateConnectedClassroomReportPdfResponse> | undefined): boolean {
    return proto3.util.equals(UpdateConnectedClassroomReportPdfResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.AssessmentReport
 */
export class AssessmentReport extends Message<AssessmentReport> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 homework_id = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * Subject name
   *
   * @generated from field: string subject = 5;
   */
  subject = "";

  /**
   * Chapter name
   *
   * @generated from field: repeated string chapters = 6;
   */
  chapters: string[] = [];

  /**
   * Overview of the test
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.TestOverview test_overview = 7;
   */
  testOverview?: TestOverview;

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionPerformance question_performances = 8;
   */
  questionPerformances: QuestionPerformance[] = [];

  /**
   * Performance of students
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentPerformance student_performances = 9;
   */
  studentPerformances: StudentPerformance[] = [];

  /**
   * Achievement of learning outcomes
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.LearningOutcomeAchievement learning_outcome_achievement = 10;
   */
  learningOutcomeAchievement?: LearningOutcomeAchievement;

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedy common_mistakes_remedy = 11;
   */
  commonMistakesRemedy: CommonMistakeAndRemedy[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ChapterWiseOverview chapter_wise_overview = 12;
   */
  chapterWiseOverview: ChapterWiseOverview[] = [];

  /**
   * @generated from field: optional string gcp_report_url = 13;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 14;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: optional string school_white_label_image_url = 15;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 16;
   */
  schoolId?: number;

  /**
   * Per-subject reports for multisubject teacher PDFs
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectReport subjects = 17;
   */
  subjects: SubjectReport[] = [];

  constructor(data?: PartialMessage<AssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.AssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "test_overview", kind: "message", T: TestOverview, opt: true },
    { no: 8, name: "question_performances", kind: "message", T: QuestionPerformance, repeated: true },
    { no: 9, name: "student_performances", kind: "message", T: StudentPerformance, repeated: true },
    { no: 10, name: "learning_outcome_achievement", kind: "message", T: LearningOutcomeAchievement, opt: true },
    { no: 11, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedy, repeated: true },
    { no: 12, name: "chapter_wise_overview", kind: "message", T: ChapterWiseOverview, repeated: true },
    { no: 13, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "created_on", kind: "message", T: Timestamp },
    { no: 15, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 17, name: "subjects", kind: "message", T: SubjectReport, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentReport {
    return new AssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentReport {
    return new AssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentReport {
    return new AssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentReport | PlainMessage<AssessmentReport> | undefined, b: AssessmentReport | PlainMessage<AssessmentReport> | undefined): boolean {
    return proto3.util.equals(AssessmentReport, a, b);
  }
}

/**
 * Overview of the test performance
 *
 * @generated from message geneo.analysis.school.assessment.apis.TestOverview
 */
export class TestOverview extends Message<TestOverview> {
  /**
   * Overall class score percentage
   *
   * @generated from field: float class_score = 1;
   */
  classScore = 0;

  /**
   * Total number of questions
   *
   * @generated from field: int32 number_of_questions = 2;
   */
  numberOfQuestions = 0;

  /**
   * Difficulty level of the test
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum overall_difficulty_level = 3;
   */
  overallDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * Total possible marks
   *
   * @generated from field: int32 total_marks = 4;
   */
  totalMarks = 0;

  /**
   * Number of students assessed
   *
   * @generated from field: int32 students_assessed = 5;
   */
  studentsAssessed = 0;

  /**
   * Summary of performance
   *
   * @generated from field: string assessment_verdict = 6;
   */
  assessmentVerdict = "";

  /**
   * List of learning outcomes
   *
   * @generated from field: repeated string learning_outcomes = 7;
   */
  learningOutcomes: string[] = [];

  /**
   * Question difficulty distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionDifficultyDistribution question_difficulty_distribution = 8;
   */
  questionDifficultyDistribution?: QuestionDifficultyDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistribution question_bloom_level_distribution = 9;
   */
  questionBloomLevelDistribution?: QuestionBloomLevelDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistributionV2 question_bloom_level_distribution_v2 = 10;
   */
  questionBloomLevelDistributionV2?: QuestionBloomLevelDistributionV2;

  /**
   * @generated from field: string difficulty = 11;
   */
  difficulty = "";

  /**
   * Optional per-subject overview to support multisubject teacher reports (V3)
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectWiseOverview subject_overview = 12;
   */
  subjectOverview: SubjectWiseOverview[] = [];

  /**
   * Per-subject question distribution (V3 multisubject support)
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionDistribution question_distribution = 13;
   */
  questionDistribution: QuestionDistribution[] = [];

  /**
   * V3: school/class/section at test overview level for convenience
   *
   * @generated from field: optional string school = 14;
   */
  school?: string;

  /**
   * @generated from field: optional string class = 15;
   */
  class?: string;

  /**
   * @generated from field: optional string section = 16;
   */
  section?: string;

  /**
   * @generated from field: optional float overall_class_score = 17;
   */
  overallClassScore?: number;

  /**
   * @generated from field: optional float student_score = 18;
   */
  studentScore?: number;

  constructor(data?: PartialMessage<TestOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TestOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "overall_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 4, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "students_assessed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "assessment_verdict", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "learning_outcomes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "question_difficulty_distribution", kind: "message", T: QuestionDifficultyDistribution },
    { no: 9, name: "question_bloom_level_distribution", kind: "message", T: QuestionBloomLevelDistribution },
    { no: 10, name: "question_bloom_level_distribution_v2", kind: "message", T: QuestionBloomLevelDistributionV2 },
    { no: 11, name: "difficulty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "subject_overview", kind: "message", T: SubjectWiseOverview, repeated: true },
    { no: 13, name: "question_distribution", kind: "message", T: QuestionDistribution, repeated: true },
    { no: 14, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 16, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 17, name: "overall_class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 18, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TestOverview {
    return new TestOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TestOverview {
    return new TestOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TestOverview {
    return new TestOverview().fromJsonString(jsonString, options);
  }

  static equals(a: TestOverview | PlainMessage<TestOverview> | undefined, b: TestOverview | PlainMessage<TestOverview> | undefined): boolean {
    return proto3.util.equals(TestOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionPerformance
 */
export class QuestionPerformance extends Message<QuestionPerformance> {
  /**
   * Question number (e.g., Q1, Q2)
   *
   * @generated from field: int32 question_number = 1;
   */
  questionNumber = 0;

  /**
   * Marks for the question
   *
   * @generated from field: int32 marks = 2;
   */
  marks = 0;

  /**
   * Number of correct answers
   *
   * @generated from field: int32 correct_answers = 3;
   */
  correctAnswers = 0;

  /**
   * @generated from field: int32 partially_correct_answers = 4;
   */
  partiallyCorrectAnswers = 0;

  /**
   * Average score percentage
   *
   * @generated from field: float average_score = 5;
   */
  averageScore = 0;

  /**
   * Difficulty level of the question
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 6;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * @generated from field: string difficulty = 7;
   */
  difficulty = "";

  constructor(data?: PartialMessage<QuestionPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "partially_correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "average_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 7, name: "difficulty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionPerformance {
    return new QuestionPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionPerformance {
    return new QuestionPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionPerformance {
    return new QuestionPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionPerformance | PlainMessage<QuestionPerformance> | undefined, b: QuestionPerformance | PlainMessage<QuestionPerformance> | undefined): boolean {
    return proto3.util.equals(QuestionPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionDifficultyDistribution
 */
export class QuestionDifficultyDistribution extends Message<QuestionDifficultyDistribution> {
  /**
   * @generated from field: int32 low_difficulty_percentage = 1;
   */
  lowDifficultyPercentage = 0;

  /**
   * @generated from field: int32 medium_difficulty_percentage = 2;
   */
  mediumDifficultyPercentage = 0;

  /**
   * @generated from field: int32 high_difficulty_percentage = 3;
   */
  highDifficultyPercentage = 0;

  constructor(data?: PartialMessage<QuestionDifficultyDistribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionDifficultyDistribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "low_difficulty_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "medium_difficulty_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "high_difficulty_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionDifficultyDistribution {
    return new QuestionDifficultyDistribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionDifficultyDistribution {
    return new QuestionDifficultyDistribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionDifficultyDistribution {
    return new QuestionDifficultyDistribution().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionDifficultyDistribution | PlainMessage<QuestionDifficultyDistribution> | undefined, b: QuestionDifficultyDistribution | PlainMessage<QuestionDifficultyDistribution> | undefined): boolean {
    return proto3.util.equals(QuestionDifficultyDistribution, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionBloomLevelDistribution
 */
export class QuestionBloomLevelDistribution extends Message<QuestionBloomLevelDistribution> {
  /**
   * percentage of questions at the Remember level
   *
   * @generated from field: int32 remember_percentage = 1;
   */
  rememberPercentage = 0;

  /**
   * percentage of questions at the Understand level
   *
   * @generated from field: int32 understand_percentage = 2;
   */
  understandPercentage = 0;

  /**
   * Coupercentagent of questions at the Apply level
   *
   * @generated from field: int32 apply_percentage = 3;
   */
  applyPercentage = 0;

  /**
   * percentage of questions at the Analyze level
   *
   * @generated from field: int32 analyze_percentage = 4;
   */
  analyzePercentage = 0;

  /**
   * percentage of questions assessing Retention
   *
   * @generated from field: int32 retention_percentage = 5;
   */
  retentionPercentage = 0;

  /**
   * percentage of questions assessing Comprehension
   *
   * @generated from field: int32 comprehension_percentage = 6;
   */
  comprehensionPercentage = 0;

  constructor(data?: PartialMessage<QuestionBloomLevelDistribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionBloomLevelDistribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "remember_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "understand_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "apply_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "analyze_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "retention_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "comprehension_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionBloomLevelDistribution {
    return new QuestionBloomLevelDistribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionBloomLevelDistribution {
    return new QuestionBloomLevelDistribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionBloomLevelDistribution {
    return new QuestionBloomLevelDistribution().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionBloomLevelDistribution | PlainMessage<QuestionBloomLevelDistribution> | undefined, b: QuestionBloomLevelDistribution | PlainMessage<QuestionBloomLevelDistribution> | undefined): boolean {
    return proto3.util.equals(QuestionBloomLevelDistribution, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionBloomLevelDistributionV2
 */
export class QuestionBloomLevelDistributionV2 extends Message<QuestionBloomLevelDistributionV2> {
  /**
   * percentage of questions at the Remember level
   *
   * @generated from field: float creation_percentage = 1;
   */
  creationPercentage = 0;

  /**
   * percentage of questions at the Understand level
   *
   * @generated from field: float evaluation_percentage = 2;
   */
  evaluationPercentage = 0;

  /**
   * Coupercentagent of questions at the Apply level
   *
   * @generated from field: float application_percentage = 3;
   */
  applicationPercentage = 0;

  /**
   * percentage of questions at the Analyze level
   *
   * @generated from field: float analysis_percentage = 4;
   */
  analysisPercentage = 0;

  /**
   * percentage of questions assessing Retention
   *
   * @generated from field: float retention_percentage = 5;
   */
  retentionPercentage = 0;

  /**
   * percentage of questions assessing Comprehension
   *
   * @generated from field: float comprehension_percentage = 6;
   */
  comprehensionPercentage = 0;

  constructor(data?: PartialMessage<QuestionBloomLevelDistributionV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionBloomLevelDistributionV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creation_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "evaluation_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "application_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "analysis_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "retention_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "comprehension_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionBloomLevelDistributionV2 {
    return new QuestionBloomLevelDistributionV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionBloomLevelDistributionV2 {
    return new QuestionBloomLevelDistributionV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionBloomLevelDistributionV2 {
    return new QuestionBloomLevelDistributionV2().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionBloomLevelDistributionV2 | PlainMessage<QuestionBloomLevelDistributionV2> | undefined, b: QuestionBloomLevelDistributionV2 | PlainMessage<QuestionBloomLevelDistributionV2> | undefined): boolean {
    return proto3.util.equals(QuestionBloomLevelDistributionV2, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.BloomLevelBreakDown
 */
export class BloomLevelBreakDown extends Message<BloomLevelBreakDown> {
  /**
   * Score for Remember level questions
   *
   * @generated from field: optional float remember_score = 1;
   */
  rememberScore?: number;

  /**
   * Score for Understand level questions
   *
   * @generated from field: optional float understand_score = 2;
   */
  understandScore?: number;

  /**
   * Score for Apply level questions
   *
   * @generated from field: optional float apply_score = 3;
   */
  applyScore?: number;

  /**
   * Score for Analyze level questions
   *
   * @generated from field: optional float analyze_score = 4;
   */
  analyzeScore?: number;

  /**
   * Percentage for Retention level performance
   *
   * @generated from field: optional float retention_score = 5;
   */
  retentionScore?: number;

  /**
   * Percentage for Comprehension level performance
   *
   * @generated from field: optional float comprehension_score = 6;
   */
  comprehensionScore?: number;

  /**
   * Overall statement regarding Bloom's taxonomy performance
   *
   * @generated from field: string overall_statement = 7;
   */
  overallStatement = "";

  constructor(data?: PartialMessage<BloomLevelBreakDown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.BloomLevelBreakDown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "remember_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 2, name: "understand_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 3, name: "apply_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 4, name: "analyze_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "retention_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "comprehension_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 7, name: "overall_statement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BloomLevelBreakDown {
    return new BloomLevelBreakDown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BloomLevelBreakDown {
    return new BloomLevelBreakDown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BloomLevelBreakDown {
    return new BloomLevelBreakDown().fromJsonString(jsonString, options);
  }

  static equals(a: BloomLevelBreakDown | PlainMessage<BloomLevelBreakDown> | undefined, b: BloomLevelBreakDown | PlainMessage<BloomLevelBreakDown> | undefined): boolean {
    return proto3.util.equals(BloomLevelBreakDown, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2
 */
export class BloomLevelBreakDownV2 extends Message<BloomLevelBreakDownV2> {
  /**
   * Score for Remember level questions
   *
   * @generated from field: optional float creation_score = 1;
   */
  creationScore?: number;

  /**
   * Score for Understand level questions
   *
   * @generated from field: optional float evaluation_score = 2;
   */
  evaluationScore?: number;

  /**
   * Score for Apply level questions
   *
   * @generated from field: optional float application_score = 3;
   */
  applicationScore?: number;

  /**
   * Score for Analyze level questions
   *
   * @generated from field: optional float analysis_score = 4;
   */
  analysisScore?: number;

  /**
   * Percentage for Retention level performance
   *
   * @generated from field: optional float retention_score = 5;
   */
  retentionScore?: number;

  /**
   * Percentage for Comprehension level performance
   *
   * @generated from field: optional float comprehension_score = 6;
   */
  comprehensionScore?: number;

  /**
   * Overall statement regarding Bloom's taxonomy performance
   *
   * @generated from field: string overall_statement = 7;
   */
  overallStatement = "";

  constructor(data?: PartialMessage<BloomLevelBreakDownV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "creation_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 2, name: "evaluation_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 3, name: "application_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 4, name: "analysis_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "retention_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "comprehension_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 7, name: "overall_statement", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BloomLevelBreakDownV2 {
    return new BloomLevelBreakDownV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BloomLevelBreakDownV2 {
    return new BloomLevelBreakDownV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BloomLevelBreakDownV2 {
    return new BloomLevelBreakDownV2().fromJsonString(jsonString, options);
  }

  static equals(a: BloomLevelBreakDownV2 | PlainMessage<BloomLevelBreakDownV2> | undefined, b: BloomLevelBreakDownV2 | PlainMessage<BloomLevelBreakDownV2> | undefined): boolean {
    return proto3.util.equals(BloomLevelBreakDownV2, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.BloomLevelClassBreakDown
 */
export class BloomLevelClassBreakDown extends Message<BloomLevelClassBreakDown> {
  /**
   * Score for Remember level questions
   *
   * @generated from field: optional float class_creation_score = 1;
   */
  classCreationScore?: number;

  /**
   * Score for Understand level questions
   *
   * @generated from field: optional float class_evaluation_score = 2;
   */
  classEvaluationScore?: number;

  /**
   * Score for Apply level questions
   *
   * @generated from field: optional float class_application_score = 3;
   */
  classApplicationScore?: number;

  /**
   * Score for Analyze level questions
   *
   * @generated from field: optional float class_analysis_score = 4;
   */
  classAnalysisScore?: number;

  /**
   * Percentage for Retention level performance
   *
   * @generated from field: optional float class_retention_score = 5;
   */
  classRetentionScore?: number;

  /**
   * Percentage for Comprehension level performance
   *
   * @generated from field: optional float class_comprehension_score = 6;
   */
  classComprehensionScore?: number;

  constructor(data?: PartialMessage<BloomLevelClassBreakDown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.BloomLevelClassBreakDown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "class_creation_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 2, name: "class_evaluation_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 3, name: "class_application_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 4, name: "class_analysis_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "class_retention_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 6, name: "class_comprehension_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BloomLevelClassBreakDown {
    return new BloomLevelClassBreakDown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BloomLevelClassBreakDown {
    return new BloomLevelClassBreakDown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BloomLevelClassBreakDown {
    return new BloomLevelClassBreakDown().fromJsonString(jsonString, options);
  }

  static equals(a: BloomLevelClassBreakDown | PlainMessage<BloomLevelClassBreakDown> | undefined, b: BloomLevelClassBreakDown | PlainMessage<BloomLevelClassBreakDown> | undefined): boolean {
    return proto3.util.equals(BloomLevelClassBreakDown, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentPerformance
 */
export class StudentPerformance extends Message<StudentPerformance> {
  /**
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * Student's overall score percentage
   *
   * @generated from field: float overall_score = 2;
   */
  overallScore = 0;

  /**
   * List of question statuses for the student
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionStatus question_statuses = 3;
   */
  questionStatuses: QuestionStatus[] = [];

  constructor(data?: PartialMessage<StudentPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "overall_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "question_statuses", kind: "message", T: QuestionStatus, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPerformance {
    return new StudentPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPerformance {
    return new StudentPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPerformance {
    return new StudentPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPerformance | PlainMessage<StudentPerformance> | undefined, b: StudentPerformance | PlainMessage<StudentPerformance> | undefined): boolean {
    return proto3.util.equals(StudentPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionStatus
 */
export class QuestionStatus extends Message<QuestionStatus> {
  /**
   * @generated from field: int32 question_number = 1;
   */
  questionNumber = 0;

  /**
   * Correct, wrong, or partially correct
   *
   * @generated from field: geneo.analysis.school.assessment.apis.AnswerStatusEnum answer_status = 2;
   */
  answerStatus = AnswerStatusEnum.ANSWER_UNDEFINED;

  constructor(data?: PartialMessage<QuestionStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "answer_status", kind: "enum", T: proto3.getEnumType(AnswerStatusEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionStatus {
    return new QuestionStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionStatus {
    return new QuestionStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionStatus {
    return new QuestionStatus().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionStatus | PlainMessage<QuestionStatus> | undefined, b: QuestionStatus | PlainMessage<QuestionStatus> | undefined): boolean {
    return proto3.util.equals(QuestionStatus, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.LearningOutcomeAchievement
 */
export class LearningOutcomeAchievement extends Message<LearningOutcomeAchievement> {
  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.LearningOutcomeAchievement.LoDetails lo_details = 1;
   */
  loDetails: LearningOutcomeAchievement_LoDetails[] = [];

  /**
   * LOS
   *
   * @generated from field: repeated string strengths = 2;
   */
  strengths: string[] = [];

  /**
   * Los
   *
   * @generated from field: repeated string weaknesses = 3;
   */
  weaknesses: string[] = [];

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDown bloom_level_breakdown = 4;
   */
  bloomLevelBreakdown?: BloomLevelBreakDown;

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2 bloom_level_breakdown_v2 = 5;
   */
  bloomLevelBreakdownV2?: BloomLevelBreakDownV2;

  constructor(data?: PartialMessage<LearningOutcomeAchievement>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.LearningOutcomeAchievement";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lo_details", kind: "message", T: LearningOutcomeAchievement_LoDetails, repeated: true },
    { no: 2, name: "strengths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "weaknesses", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "bloom_level_breakdown", kind: "message", T: BloomLevelBreakDown },
    { no: 5, name: "bloom_level_breakdown_v2", kind: "message", T: BloomLevelBreakDownV2 },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LearningOutcomeAchievement {
    return new LearningOutcomeAchievement().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LearningOutcomeAchievement {
    return new LearningOutcomeAchievement().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LearningOutcomeAchievement {
    return new LearningOutcomeAchievement().fromJsonString(jsonString, options);
  }

  static equals(a: LearningOutcomeAchievement | PlainMessage<LearningOutcomeAchievement> | undefined, b: LearningOutcomeAchievement | PlainMessage<LearningOutcomeAchievement> | undefined): boolean {
    return proto3.util.equals(LearningOutcomeAchievement, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.LearningOutcomeAchievement.LoDetails
 */
export class LearningOutcomeAchievement_LoDetails extends Message<LearningOutcomeAchievement_LoDetails> {
  /**
   * Description of the learning outcome
   *
   * @generated from field: string description = 1;
   */
  description = "";

  /**
   * Score achieved in percentage
   *
   * @generated from field: float score_percentage = 2;
   */
  scorePercentage = 0;

  /**
   * Suggested action (e.g., "Revise", "Reteach")
   *
   * @generated from field: string action_required = 3;
   */
  actionRequired = "";

  constructor(data?: PartialMessage<LearningOutcomeAchievement_LoDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.LearningOutcomeAchievement.LoDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "action_required", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LearningOutcomeAchievement_LoDetails {
    return new LearningOutcomeAchievement_LoDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LearningOutcomeAchievement_LoDetails {
    return new LearningOutcomeAchievement_LoDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LearningOutcomeAchievement_LoDetails {
    return new LearningOutcomeAchievement_LoDetails().fromJsonString(jsonString, options);
  }

  static equals(a: LearningOutcomeAchievement_LoDetails | PlainMessage<LearningOutcomeAchievement_LoDetails> | undefined, b: LearningOutcomeAchievement_LoDetails | PlainMessage<LearningOutcomeAchievement_LoDetails> | undefined): boolean {
    return proto3.util.equals(LearningOutcomeAchievement_LoDetails, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.LearningOutcome
 */
export class LearningOutcome extends Message<LearningOutcome> {
  /**
   * @generated from field: string description = 1;
   */
  description = "";

  /**
   * Score achieved in percentage
   *
   * @generated from field: float score_percentage = 2;
   */
  scorePercentage = 0;

  /**
   * Suggested action (e.g., "Revise", "Reteach")
   *
   * @generated from field: string action_required = 3;
   */
  actionRequired = "";

  constructor(data?: PartialMessage<LearningOutcome>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.LearningOutcome";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "action_required", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LearningOutcome {
    return new LearningOutcome().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LearningOutcome {
    return new LearningOutcome().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LearningOutcome {
    return new LearningOutcome().fromJsonString(jsonString, options);
  }

  static equals(a: LearningOutcome | PlainMessage<LearningOutcome> | undefined, b: LearningOutcome | PlainMessage<LearningOutcome> | undefined): boolean {
    return proto3.util.equals(LearningOutcome, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ChapterWiseOverview
 */
export class ChapterWiseOverview extends Message<ChapterWiseOverview> {
  /**
   * @generated from field: string chapter_name = 1;
   */
  chapterName = "";

  /**
   * Score achieved in percentage
   *
   * @generated from field: float overall_class_score = 2;
   */
  overallClassScore = 0;

  /**
   * @generated from field: int32 no_of_questions = 3;
   */
  noOfQuestions = 0;

  constructor(data?: PartialMessage<ChapterWiseOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ChapterWiseOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "overall_class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterWiseOverview {
    return new ChapterWiseOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterWiseOverview {
    return new ChapterWiseOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterWiseOverview {
    return new ChapterWiseOverview().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterWiseOverview | PlainMessage<ChapterWiseOverview> | undefined, b: ChapterWiseOverview | PlainMessage<ChapterWiseOverview> | undefined): boolean {
    return proto3.util.equals(ChapterWiseOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.CommonMistakeAndRemedy
 */
export class CommonMistakeAndRemedy extends Message<CommonMistakeAndRemedy> {
  /**
   * @generated from field: string question_heading = 1;
   */
  questionHeading = "";

  /**
   * @generated from field: geneo.content.db.Question question_details = 2;
   */
  questionDetails?: Question;

  /**
   * Question number where mistake occurred
   *
   * @generated from field: optional int32 question_number = 3;
   */
  questionNumber?: number;

  /**
   * Difficulty level of the question
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum difficulty_level = 4;
   */
  difficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * Average time taken to answer the question in seconds
   *
   * @generated from field: int32 avg_time_to_answer = 5;
   */
  avgTimeToAnswer = 0;

  /**
   * Most common wrong answer given by students
   *
   * @generated from field: string most_common_wrong_answer = 6;
   */
  mostCommonWrongAnswer = "";

  /**
   * Class score percentage for that question
   *
   * @generated from field: float class_score_percentage = 7;
   */
  classScorePercentage = 0;

  /**
   * Suggested remedy content for improvement
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.RemedyContent remedy_content = 8;
   */
  remedyContent: RemedyContent[] = [];

  /**
   * Explanation of the correct answer or concept
   *
   * @generated from field: string explanation = 9;
   */
  explanation = "";

  constructor(data?: PartialMessage<CommonMistakeAndRemedy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.CommonMistakeAndRemedy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_heading", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_details", kind: "message", T: Question },
    { no: 3, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 5, name: "avg_time_to_answer", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "most_common_wrong_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "class_score_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "remedy_content", kind: "message", T: RemedyContent, repeated: true },
    { no: 9, name: "explanation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommonMistakeAndRemedy {
    return new CommonMistakeAndRemedy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommonMistakeAndRemedy {
    return new CommonMistakeAndRemedy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommonMistakeAndRemedy {
    return new CommonMistakeAndRemedy().fromJsonString(jsonString, options);
  }

  static equals(a: CommonMistakeAndRemedy | PlainMessage<CommonMistakeAndRemedy> | undefined, b: CommonMistakeAndRemedy | PlainMessage<CommonMistakeAndRemedy> | undefined): boolean {
    return proto3.util.equals(CommonMistakeAndRemedy, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt
 */
export class CommonMistakeAndRemedyKdt extends Message<CommonMistakeAndRemedyKdt> {
  /**
   * @generated from field: geneo.content.db.Question question_details = 1;
   */
  questionDetails?: Question;

  /**
   * Question number where mistake occurred
   *
   * @generated from field: optional int32 question_number = 2;
   */
  questionNumber?: number;

  /**
   *  time taken to answer the question in seconds
   *
   * @generated from field: string time_to_answer = 3;
   */
  timeToAnswer = "";

  /**
   *   wrong answer given by student
   *
   * @generated from field: string your_answer = 4;
   */
  yourAnswer = "";

  /**
   * Class score percentage for that question
   *
   * @generated from field: float class_score_percentage = 5;
   */
  classScorePercentage = 0;

  /**
   * Suggested remedy content for improvement
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.RemedyContent remedy_content = 6;
   */
  remedyContent: RemedyContent[] = [];

  /**
   * Explanation of the correct answer or concept
   *
   * @generated from field: string explanation = 7;
   */
  explanation = "";

  /**
   * Teacher's remark on student's response
   *
   * @generated from field: optional string remark = 8;
   */
  remark?: string;

  constructor(data?: PartialMessage<CommonMistakeAndRemedyKdt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_details", kind: "message", T: Question },
    { no: 2, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "time_to_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "your_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "class_score_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "remedy_content", kind: "message", T: RemedyContent, repeated: true },
    { no: 7, name: "explanation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "remark", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommonMistakeAndRemedyKdt {
    return new CommonMistakeAndRemedyKdt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommonMistakeAndRemedyKdt {
    return new CommonMistakeAndRemedyKdt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommonMistakeAndRemedyKdt {
    return new CommonMistakeAndRemedyKdt().fromJsonString(jsonString, options);
  }

  static equals(a: CommonMistakeAndRemedyKdt | PlainMessage<CommonMistakeAndRemedyKdt> | undefined, b: CommonMistakeAndRemedyKdt | PlainMessage<CommonMistakeAndRemedyKdt> | undefined): boolean {
    return proto3.util.equals(CommonMistakeAndRemedyKdt, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ResourceContent
 */
export class ResourceContent extends Message<ResourceContent> {
  /**
   * Identifier for the resource
   *
   * @generated from field: string resource_id = 1;
   */
  resourceId = "";

  /**
   * Title of the resource.
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * URL of the resource's poster image.
   *
   * @generated from field: string poster_image_url = 3;
   */
  posterImageUrl = "";

  /**
   * Estimated time to complete the resource in minutes.
   *
   * @generated from field: int32 estimated_time_in_min = 4;
   */
  estimatedTimeInMin = 0;

  /**
   * Type of the resource (e.g., video, document).
   *
   * @generated from field: geneo.content.db.Resource.ResourceEnum resource_type = 5;
   */
  resourceType = Resource_ResourceEnum.RESOURCE_TYPE_UNDEFINED;

  /**
   * Category type of the resource (e.g., science, history).
   *
   * @generated from field: geneo.content.db.ResourceCategoryEnum resource_category = 6;
   */
  resourceCategory = ResourceCategoryEnum.RESOURCE_CATEGORY_UNDEFINED;

  /**
   * @generated from field: string category = 7;
   */
  category = "";

  /**
   * @generated from field: string type = 8;
   */
  type = "";

  constructor(data?: PartialMessage<ResourceContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ResourceContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resource_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "poster_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "estimated_time_in_min", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "resource_type", kind: "enum", T: proto3.getEnumType(Resource_ResourceEnum) },
    { no: 6, name: "resource_category", kind: "enum", T: proto3.getEnumType(ResourceCategoryEnum) },
    { no: 7, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResourceContent {
    return new ResourceContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResourceContent {
    return new ResourceContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResourceContent {
    return new ResourceContent().fromJsonString(jsonString, options);
  }

  static equals(a: ResourceContent | PlainMessage<ResourceContent> | undefined, b: ResourceContent | PlainMessage<ResourceContent> | undefined): boolean {
    return proto3.util.equals(ResourceContent, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.RemedyContent
 */
export class RemedyContent extends Message<RemedyContent> {
  /**
   * Chapter related to the remedy content
   *
   * @generated from field: string chapter = 1;
   */
  chapter = "";

  /**
   * Topic related to the remedy content
   *
   * @generated from field: string topic = 2;
   */
  topic = "";

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ResourceContent resources = 3;
   */
  resources: ResourceContent[] = [];

  constructor(data?: PartialMessage<RemedyContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.RemedyContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "resources", kind: "message", T: ResourceContent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RemedyContent {
    return new RemedyContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RemedyContent {
    return new RemedyContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RemedyContent {
    return new RemedyContent().fromJsonString(jsonString, options);
  }

  static equals(a: RemedyContent | PlainMessage<RemedyContent> | undefined, b: RemedyContent | PlainMessage<RemedyContent> | undefined): boolean {
    return proto3.util.equals(RemedyContent, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentKdtAssessmentReportRequest
 */
export class FetchStudentKdtAssessmentReportRequest extends Message<FetchStudentKdtAssessmentReportRequest> {
  /**
   * IDs for the Kdt Assessment
   *
   * @generated from field: repeated int64 homework_ids = 1;
   */
  homeworkIds: bigint[] = [];

  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  constructor(data?: PartialMessage<FetchStudentKdtAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentKdtAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_ids", kind: "scalar", T: 3 /* ScalarType.INT64 */, repeated: true },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentKdtAssessmentReportRequest {
    return new FetchStudentKdtAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentKdtAssessmentReportRequest {
    return new FetchStudentKdtAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentKdtAssessmentReportRequest {
    return new FetchStudentKdtAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentKdtAssessmentReportRequest | PlainMessage<FetchStudentKdtAssessmentReportRequest> | undefined, b: FetchStudentKdtAssessmentReportRequest | PlainMessage<FetchStudentKdtAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentKdtAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentHwReportRequest
 */
export class FetchStudentHwReportRequest extends Message<FetchStudentHwReportRequest> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 homework_id = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  constructor(data?: PartialMessage<FetchStudentHwReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentHwReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentHwReportRequest {
    return new FetchStudentHwReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentHwReportRequest {
    return new FetchStudentHwReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentHwReportRequest {
    return new FetchStudentHwReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentHwReportRequest | PlainMessage<FetchStudentHwReportRequest> | undefined, b: FetchStudentHwReportRequest | PlainMessage<FetchStudentHwReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentHwReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentHwReportResponse
 */
export class FetchStudentHwReportResponse extends Message<FetchStudentHwReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentHwReport data = 4;
   */
  data?: StudentHwReport;

  constructor(data?: PartialMessage<FetchStudentHwReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentHwReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentHwReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentHwReportResponse {
    return new FetchStudentHwReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentHwReportResponse {
    return new FetchStudentHwReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentHwReportResponse {
    return new FetchStudentHwReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentHwReportResponse | PlainMessage<FetchStudentHwReportResponse> | undefined, b: FetchStudentHwReportResponse | PlainMessage<FetchStudentHwReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchStudentHwReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV2Request
 */
export class FetchStudentAssessmentReportV2Request extends Message<FetchStudentAssessmentReportV2Request> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportV2Request {
    return new FetchStudentAssessmentReportV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV2Request {
    return new FetchStudentAssessmentReportV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV2Request {
    return new FetchStudentAssessmentReportV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportV2Request | PlainMessage<FetchStudentAssessmentReportV2Request> | undefined, b: FetchStudentAssessmentReportV2Request | PlainMessage<FetchStudentAssessmentReportV2Request> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportV2Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV2Response
 */
export class FetchStudentAssessmentReportV2Response extends Message<FetchStudentAssessmentReportV2Response> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentAssessmentReportData data = 4;
   */
  data?: StudentAssessmentReportData;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportV2Response {
    return new FetchStudentAssessmentReportV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV2Response {
    return new FetchStudentAssessmentReportV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV2Response {
    return new FetchStudentAssessmentReportV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportV2Response | PlainMessage<FetchStudentAssessmentReportV2Response> | undefined, b: FetchStudentAssessmentReportV2Response | PlainMessage<FetchStudentAssessmentReportV2Response> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportV2Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentSummaryReportRequest
 */
export class FetchStudentAssessmentSummaryReportRequest extends Message<FetchStudentAssessmentSummaryReportRequest> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentAssessmentSummaryReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentSummaryReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentSummaryReportRequest {
    return new FetchStudentAssessmentSummaryReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentSummaryReportRequest {
    return new FetchStudentAssessmentSummaryReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentSummaryReportRequest {
    return new FetchStudentAssessmentSummaryReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentSummaryReportRequest | PlainMessage<FetchStudentAssessmentSummaryReportRequest> | undefined, b: FetchStudentAssessmentSummaryReportRequest | PlainMessage<FetchStudentAssessmentSummaryReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentSummaryReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentSummaryReportResponse
 */
export class FetchStudentAssessmentSummaryReportResponse extends Message<FetchStudentAssessmentSummaryReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentAssessmentReportData data = 4;
   */
  data?: StudentAssessmentReportData;

  constructor(data?: PartialMessage<FetchStudentAssessmentSummaryReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentSummaryReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentSummaryReportResponse {
    return new FetchStudentAssessmentSummaryReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentSummaryReportResponse {
    return new FetchStudentAssessmentSummaryReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentSummaryReportResponse {
    return new FetchStudentAssessmentSummaryReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentSummaryReportResponse | PlainMessage<FetchStudentAssessmentSummaryReportResponse> | undefined, b: FetchStudentAssessmentSummaryReportResponse | PlainMessage<FetchStudentAssessmentSummaryReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentSummaryReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportRequest
 */
export class FetchStudentsBulkAssessmentReportRequest extends Message<FetchStudentsBulkAssessmentReportRequest> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: bool is_summary_report = 2;
   */
  isSummaryReport = false;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentsBulkAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "is_summary_report", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentsBulkAssessmentReportRequest {
    return new FetchStudentsBulkAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportRequest {
    return new FetchStudentsBulkAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportRequest {
    return new FetchStudentsBulkAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentsBulkAssessmentReportRequest | PlainMessage<FetchStudentsBulkAssessmentReportRequest> | undefined, b: FetchStudentsBulkAssessmentReportRequest | PlainMessage<FetchStudentsBulkAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentsBulkAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportResponse
 */
export class FetchStudentsBulkAssessmentReportResponse extends Message<FetchStudentsBulkAssessmentReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentsAssessmentBulkReportData data = 4;
   */
  data?: StudentsAssessmentBulkReportData;

  constructor(data?: PartialMessage<FetchStudentsBulkAssessmentReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentsAssessmentBulkReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentsBulkAssessmentReportResponse {
    return new FetchStudentsBulkAssessmentReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportResponse {
    return new FetchStudentsBulkAssessmentReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportResponse {
    return new FetchStudentsBulkAssessmentReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentsBulkAssessmentReportResponse | PlainMessage<FetchStudentsBulkAssessmentReportResponse> | undefined, b: FetchStudentsBulkAssessmentReportResponse | PlainMessage<FetchStudentsBulkAssessmentReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchStudentsBulkAssessmentReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentsAssessmentBulkReportData
 */
export class StudentsAssessmentBulkReportData extends Message<StudentsAssessmentBulkReportData> {
  /**
   * URL for the zip report stored in GCP
   *
   * @generated from field: optional string bulk_report_url = 1;
   */
  bulkReportUrl?: string;

  /**
   * Unique job identifier for tracking
   *
   * @generated from field: string job_id = 2;
   */
  jobId = "";

  /**
   * Total number of reports to generate
   *
   * @generated from field: int32 total_reports = 3;
   */
  totalReports = 0;

  /**
   * Current status of the bulk job
   *
   * @generated from field: geneo.lms.db.BulkJobStatus status = 4;
   */
  status = BulkJobStatus.UNDEFINED;

  constructor(data?: PartialMessage<StudentsAssessmentBulkReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentsAssessmentBulkReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bulk_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_reports", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(BulkJobStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentsAssessmentBulkReportData {
    return new StudentsAssessmentBulkReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentsAssessmentBulkReportData {
    return new StudentsAssessmentBulkReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentsAssessmentBulkReportData {
    return new StudentsAssessmentBulkReportData().fromJsonString(jsonString, options);
  }

  static equals(a: StudentsAssessmentBulkReportData | PlainMessage<StudentsAssessmentBulkReportData> | undefined, b: StudentsAssessmentBulkReportData | PlainMessage<StudentsAssessmentBulkReportData> | undefined): boolean {
    return proto3.util.equals(StudentsAssessmentBulkReportData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.GetBulkReportStatusRequest
 */
export class GetBulkReportStatusRequest extends Message<GetBulkReportStatusRequest> {
  /**
   * Unique job identifier
   *
   * @generated from field: string job_id = 1;
   */
  jobId = "";

  constructor(data?: PartialMessage<GetBulkReportStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.GetBulkReportStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBulkReportStatusRequest {
    return new GetBulkReportStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBulkReportStatusRequest {
    return new GetBulkReportStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBulkReportStatusRequest {
    return new GetBulkReportStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBulkReportStatusRequest | PlainMessage<GetBulkReportStatusRequest> | undefined, b: GetBulkReportStatusRequest | PlainMessage<GetBulkReportStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetBulkReportStatusRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.GetBulkReportStatusResponse
 */
export class GetBulkReportStatusResponse extends Message<GetBulkReportStatusResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * Status data
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BulkReportStatusData data = 4;
   */
  data?: BulkReportStatusData;

  constructor(data?: PartialMessage<GetBulkReportStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.GetBulkReportStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: BulkReportStatusData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBulkReportStatusResponse {
    return new GetBulkReportStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBulkReportStatusResponse {
    return new GetBulkReportStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBulkReportStatusResponse {
    return new GetBulkReportStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBulkReportStatusResponse | PlainMessage<GetBulkReportStatusResponse> | undefined, b: GetBulkReportStatusResponse | PlainMessage<GetBulkReportStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetBulkReportStatusResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.BulkReportStatusData
 */
export class BulkReportStatusData extends Message<BulkReportStatusData> {
  /**
   * Unique job identifier
   *
   * @generated from field: string job_id = 1;
   */
  jobId = "";

  /**
   * Current status
   *
   * @generated from field: geneo.lms.db.BulkJobStatus status = 2;
   */
  status = BulkJobStatus.UNDEFINED;

  /**
   * Total number of reports
   *
   * @generated from field: int32 total_reports = 3;
   */
  totalReports = 0;

  /**
   * Number of completed reports
   *
   * @generated from field: int32 completed_reports = 4;
   */
  completedReports = 0;

  /**
   * Download URL when completed
   *
   * @generated from field: optional string download_url = 5;
   */
  downloadUrl?: string;

  /**
   * Error message if failed
   *
   * @generated from field: optional string error_message = 6;
   */
  errorMessage?: string;

  /**
   * Job creation time
   *
   * @generated from field: google.protobuf.Timestamp created_on = 7;
   */
  createdOn?: Timestamp;

  /**
   * Job completion time
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 8;
   */
  completedAt?: Timestamp;

  constructor(data?: PartialMessage<BulkReportStatusData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.BulkReportStatusData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(BulkJobStatus) },
    { no: 3, name: "total_reports", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "completed_reports", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "created_on", kind: "message", T: Timestamp },
    { no: 8, name: "completed_at", kind: "message", T: Timestamp, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BulkReportStatusData {
    return new BulkReportStatusData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BulkReportStatusData {
    return new BulkReportStatusData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BulkReportStatusData {
    return new BulkReportStatusData().fromJsonString(jsonString, options);
  }

  static equals(a: BulkReportStatusData | PlainMessage<BulkReportStatusData> | undefined, b: BulkReportStatusData | PlainMessage<BulkReportStatusData> | undefined): boolean {
    return proto3.util.equals(BulkReportStatusData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentAssessmentReportData
 */
export class StudentAssessmentReportData extends Message<StudentAssessmentReportData> {
  /**
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * @generated from field: string assessment_type = 5;
   */
  assessmentType = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.HomeworkOverview test_overview = 6;
   */
  testOverview?: HomeworkOverview;

  /**
   * Report creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 8;
   */
  createdOn?: Timestamp;

  /**
   * URL for the report stored in GCP
   *
   * @generated from field: optional string gcp_report_url = 9;
   */
  gcpReportUrl?: string;

  /**
   * Chapter name
   *
   * @generated from field: repeated string chapters = 10;
   */
  chapters: string[] = [];

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt common_mistakes_remedy = 11;
   */
  commonMistakesRemedy: CommonMistakeAndRemedyKdt[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.studentChapterWiseOverview chapter_wise_overview = 12;
   */
  chapterWiseOverview: studentChapterWiseOverview[] = [];

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentHwQuestionOverview question_performances = 13;
   */
  questionPerformances: StudentHwQuestionOverview[] = [];

  /**
   * LOS
   *
   * @generated from field: repeated string strengths = 14;
   */
  strengths: string[] = [];

  /**
   * Los
   *
   * @generated from field: repeated string growth_areas = 15;
   */
  growthAreas: string[] = [];

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2 bloom_level_breakdown_v2 = 16;
   */
  bloomLevelBreakdownV2?: BloomLevelBreakDownV2;

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelClassBreakDown bloom_level_class_breakdown = 17;
   */
  bloomLevelClassBreakdown?: BloomLevelClassBreakDown;

  /**
   * Name of the chapter
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.KnowledgeGraph knowledge_graph = 18;
   */
  knowledgeGraph: KnowledgeGraph[] = [];

  /**
   * subject name
   *
   * @generated from field: string subject = 19;
   */
  subject = "";

  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 20;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional string school_white_label_image_url = 21;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 22;
   */
  schoolId?: number;

  /**
   * @generated from field: optional geneo.lms.db.ModeOfConductionEnum mode_of_conduction = 23;
   */
  modeOfConduction?: ModeOfConductionEnum;

  /**
   * @generated from field: optional int32 attempt_number = 24;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 25;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * URL for the summary report stored in GCP
   *
   * @generated from field: optional string gcp_summary_report_url = 26;
   */
  gcpSummaryReportUrl?: string;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 27;
   */
  markingSchemeType?: MarkingSchemeEnum;

  constructor(data?: PartialMessage<StudentAssessmentReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentAssessmentReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "assessment_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "test_overview", kind: "message", T: HomeworkOverview },
    { no: 8, name: "created_on", kind: "message", T: Timestamp },
    { no: 9, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedyKdt, repeated: true },
    { no: 12, name: "chapter_wise_overview", kind: "message", T: studentChapterWiseOverview, repeated: true },
    { no: 13, name: "question_performances", kind: "message", T: StudentHwQuestionOverview, repeated: true },
    { no: 14, name: "strengths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "growth_areas", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "bloom_level_breakdown_v2", kind: "message", T: BloomLevelBreakDownV2 },
    { no: 17, name: "bloom_level_class_breakdown", kind: "message", T: BloomLevelClassBreakDown },
    { no: 18, name: "knowledge_graph", kind: "message", T: KnowledgeGraph, repeated: true },
    { no: 19, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "mode_of_conduction", kind: "enum", T: proto3.getEnumType(ModeOfConductionEnum), opt: true },
    { no: 24, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 25, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 26, name: "gcp_summary_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 27, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentReportData {
    return new StudentAssessmentReportData().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentReportData | PlainMessage<StudentAssessmentReportData> | undefined, b: StudentAssessmentReportData | PlainMessage<StudentAssessmentReportData> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentReportData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentHwReport
 */
export class StudentHwReport extends Message<StudentHwReport> {
  /**
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * @generated from field: string assessment_type = 5;
   */
  assessmentType = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.HomeworkOverview test_overview = 6;
   */
  testOverview?: HomeworkOverview;

  /**
   * Report creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 8;
   */
  createdOn?: Timestamp;

  /**
   * URL for the report stored in GCP
   *
   * @generated from field: optional string gcp_report_url = 9;
   */
  gcpReportUrl?: string;

  /**
   * Chapter name
   *
   * @generated from field: repeated string chapters = 10;
   */
  chapters: string[] = [];

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt common_mistakes_remedy = 11;
   */
  commonMistakesRemedy: CommonMistakeAndRemedyKdt[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.studentChapterWiseOverview chapter_wise_overview = 12;
   */
  chapterWiseOverview: studentChapterWiseOverview[] = [];

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentHwQuestionOverview question_performances = 13;
   */
  questionPerformances: StudentHwQuestionOverview[] = [];

  /**
   * LOS
   *
   * @generated from field: repeated string strengths = 14;
   */
  strengths: string[] = [];

  /**
   * Los
   *
   * @generated from field: repeated string growth_areas = 15;
   */
  growthAreas: string[] = [];

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2 bloom_level_breakdown_v2 = 16;
   */
  bloomLevelBreakdownV2?: BloomLevelBreakDownV2;

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelClassBreakDown bloom_level_class_breakdown = 17;
   */
  bloomLevelClassBreakdown?: BloomLevelClassBreakDown;

  /**
   * Name of the chapter
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.KnowledgeGraph knowledge_graph = 18;
   */
  knowledgeGraph: KnowledgeGraph[] = [];

  /**
   * subject name
   *
   * @generated from field: string subject = 19;
   */
  subject = "";

  /**
   * ID for the Assessment
   *
   * @generated from field: int64 homework_id = 20;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: optional string school_white_label_image_url = 21;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 22;
   */
  schoolId?: number;

  /**
   * @generated from field: optional geneo.lms.db.MarkingSchemeEnum marking_scheme_type = 23;
   */
  markingSchemeType?: MarkingSchemeEnum;

  constructor(data?: PartialMessage<StudentHwReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentHwReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "assessment_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "test_overview", kind: "message", T: HomeworkOverview },
    { no: 8, name: "created_on", kind: "message", T: Timestamp },
    { no: 9, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedyKdt, repeated: true },
    { no: 12, name: "chapter_wise_overview", kind: "message", T: studentChapterWiseOverview, repeated: true },
    { no: 13, name: "question_performances", kind: "message", T: StudentHwQuestionOverview, repeated: true },
    { no: 14, name: "strengths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "growth_areas", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "bloom_level_breakdown_v2", kind: "message", T: BloomLevelBreakDownV2 },
    { no: 17, name: "bloom_level_class_breakdown", kind: "message", T: BloomLevelClassBreakDown },
    { no: 18, name: "knowledge_graph", kind: "message", T: KnowledgeGraph, repeated: true },
    { no: 19, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "homework_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 22, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 23, name: "marking_scheme_type", kind: "enum", T: proto3.getEnumType(MarkingSchemeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentHwReport {
    return new StudentHwReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentHwReport {
    return new StudentHwReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentHwReport {
    return new StudentHwReport().fromJsonString(jsonString, options);
  }

  static equals(a: StudentHwReport | PlainMessage<StudentHwReport> | undefined, b: StudentHwReport | PlainMessage<StudentHwReport> | undefined): boolean {
    return proto3.util.equals(StudentHwReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.studentChapterWiseOverview
 */
export class studentChapterWiseOverview extends Message<studentChapterWiseOverview> {
  /**
   * @generated from field: string chapter_name = 1;
   */
  chapterName = "";

  /**
   * Score achieved in percentage
   *
   * @generated from field: float overall_class_score = 2;
   */
  overallClassScore = 0;

  /**
   * @generated from field: int32 no_of_questions = 3;
   */
  noOfQuestions = 0;

  /**
   * Score achieved in percentage
   *
   * @generated from field: float student_score = 4;
   */
  studentScore = 0;

  /**
   * total marks
   *
   * @generated from field: float marks = 5;
   */
  marks = 0;

  /**
   * marks achieved by student
   *
   * @generated from field: float marks_achieved = 6;
   */
  marksAchieved = 0;

  constructor(data?: PartialMessage<studentChapterWiseOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.studentChapterWiseOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "overall_class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "no_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "marks", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "marks_achieved", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): studentChapterWiseOverview {
    return new studentChapterWiseOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): studentChapterWiseOverview {
    return new studentChapterWiseOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): studentChapterWiseOverview {
    return new studentChapterWiseOverview().fromJsonString(jsonString, options);
  }

  static equals(a: studentChapterWiseOverview | PlainMessage<studentChapterWiseOverview> | undefined, b: studentChapterWiseOverview | PlainMessage<studentChapterWiseOverview> | undefined): boolean {
    return proto3.util.equals(studentChapterWiseOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.HomeworkOverview
 */
export class HomeworkOverview extends Message<HomeworkOverview> {
  /**
   * student score percentage
   *
   * @generated from field: float student_score = 1;
   */
  studentScore = 0;

  /**
   * Total number of questions
   *
   * @generated from field: int32 number_of_questions = 2;
   */
  numberOfQuestions = 0;

  /**
   * Difficulty level of the test
   *
   * @generated from field: geneo.content.db.DifficultyLevelEnum overall_difficulty_level = 3;
   */
  overallDifficultyLevel = DifficultyLevelEnum.DIFFICULTY_LEVEL_UNDEFINED;

  /**
   * Total possible marks
   *
   * @generated from field: int32 total_marks = 4;
   */
  totalMarks = 0;

  /**
   * Number of students assessed
   *
   * @generated from field: int32 chapters_assessed = 5;
   */
  chaptersAssessed = 0;

  /**
   * Summary of performance
   *
   * @generated from field: string assessment_verdict = 6;
   */
  assessmentVerdict = "";

  /**
   * List of learning outcomes
   *
   * @generated from field: float overall_class_score = 7;
   */
  overallClassScore = 0;

  /**
   * Question difficulty distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionDifficultyDistribution question_difficulty_distribution = 8;
   */
  questionDifficultyDistribution?: QuestionDifficultyDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistribution question_bloom_level_distribution = 9;
   */
  questionBloomLevelDistribution?: QuestionBloomLevelDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistributionV2 question_bloom_level_distribution_v2 = 10;
   */
  questionBloomLevelDistributionV2?: QuestionBloomLevelDistributionV2;

  /**
   * @generated from field: string difficulty = 11;
   */
  difficulty = "";

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.conceptLearningOutcomes concept_learning_outcomes = 12;
   */
  conceptLearningOutcomes: conceptLearningOutcomes[] = [];

  /**
   * @generated from field: repeated string learning_outcomes = 13;
   */
  learningOutcomes: string[] = [];

  /**
   * Actual marks received by the student
   *
   * @generated from field: float marks_received = 14;
   */
  marksReceived = 0;

  constructor(data?: PartialMessage<HomeworkOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.HomeworkOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "overall_difficulty_level", kind: "enum", T: proto3.getEnumType(DifficultyLevelEnum) },
    { no: 4, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "chapters_assessed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "assessment_verdict", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "overall_class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "question_difficulty_distribution", kind: "message", T: QuestionDifficultyDistribution },
    { no: 9, name: "question_bloom_level_distribution", kind: "message", T: QuestionBloomLevelDistribution },
    { no: 10, name: "question_bloom_level_distribution_v2", kind: "message", T: QuestionBloomLevelDistributionV2 },
    { no: 11, name: "difficulty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "concept_learning_outcomes", kind: "message", T: conceptLearningOutcomes, repeated: true },
    { no: 13, name: "learning_outcomes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "marks_received", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HomeworkOverview {
    return new HomeworkOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HomeworkOverview {
    return new HomeworkOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HomeworkOverview {
    return new HomeworkOverview().fromJsonString(jsonString, options);
  }

  static equals(a: HomeworkOverview | PlainMessage<HomeworkOverview> | undefined, b: HomeworkOverview | PlainMessage<HomeworkOverview> | undefined): boolean {
    return proto3.util.equals(HomeworkOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.conceptLearningOutcomes
 */
export class conceptLearningOutcomes extends Message<conceptLearningOutcomes> {
  /**
   * @generated from field: string concept = 1;
   */
  concept = "";

  /**
   * @generated from field: string learning_outcome = 2;
   */
  learningOutcome = "";

  constructor(data?: PartialMessage<conceptLearningOutcomes>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.conceptLearningOutcomes";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "concept", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): conceptLearningOutcomes {
    return new conceptLearningOutcomes().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): conceptLearningOutcomes {
    return new conceptLearningOutcomes().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): conceptLearningOutcomes {
    return new conceptLearningOutcomes().fromJsonString(jsonString, options);
  }

  static equals(a: conceptLearningOutcomes | PlainMessage<conceptLearningOutcomes> | undefined, b: conceptLearningOutcomes | PlainMessage<conceptLearningOutcomes> | undefined): boolean {
    return proto3.util.equals(conceptLearningOutcomes, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentKdtAssessmentReportResonse
 */
export class FetchStudentKdtAssessmentReportResonse extends Message<FetchStudentKdtAssessmentReportResonse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentKnowledgeDiagnosticAssessmentReport data = 4;
   */
  data?: StudentKnowledgeDiagnosticAssessmentReport;

  constructor(data?: PartialMessage<FetchStudentKdtAssessmentReportResonse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentKdtAssessmentReportResonse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentKnowledgeDiagnosticAssessmentReport },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentKdtAssessmentReportResonse {
    return new FetchStudentKdtAssessmentReportResonse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentKdtAssessmentReportResonse {
    return new FetchStudentKdtAssessmentReportResonse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentKdtAssessmentReportResonse {
    return new FetchStudentKdtAssessmentReportResonse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentKdtAssessmentReportResonse | PlainMessage<FetchStudentKdtAssessmentReportResonse> | undefined, b: FetchStudentKdtAssessmentReportResonse | PlainMessage<FetchStudentKdtAssessmentReportResonse> | undefined): boolean {
    return proto3.util.equals(FetchStudentKdtAssessmentReportResonse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentKnowledgeDiagnosticAssessmentReport
 */
export class StudentKnowledgeDiagnosticAssessmentReport extends Message<StudentKnowledgeDiagnosticAssessmentReport> {
  /**
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * School name
   *
   * @generated from field: string school = 2;
   */
  school = "";

  /**
   * Class name
   *
   * @generated from field: string class = 3;
   */
  class = "";

  /**
   * Section name
   *
   * @generated from field: string section = 4;
   */
  section = "";

  /**
   * @generated from field: string assessment_type = 5;
   */
  assessmentType = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.SubjectTestOverview test_overview = 6;
   */
  testOverview?: SubjectTestOverview;

  /**
   * List of subject reports
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectReport subjects = 7;
   */
  subjects: SubjectReport[] = [];

  /**
   * Report creation timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_on = 8;
   */
  createdOn?: Timestamp;

  /**
   * URL for the report stored in GCP
   *
   * @generated from field: optional string gcp_report_url = 9;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: optional string school_white_label_image_url = 10;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 11;
   */
  schoolId?: number;

  constructor(data?: PartialMessage<StudentKnowledgeDiagnosticAssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentKnowledgeDiagnosticAssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "school", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "assessment_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "test_overview", kind: "message", T: SubjectTestOverview },
    { no: 7, name: "subjects", kind: "message", T: SubjectReport, repeated: true },
    { no: 8, name: "created_on", kind: "message", T: Timestamp },
    { no: 9, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentKnowledgeDiagnosticAssessmentReport {
    return new StudentKnowledgeDiagnosticAssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentKnowledgeDiagnosticAssessmentReport {
    return new StudentKnowledgeDiagnosticAssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentKnowledgeDiagnosticAssessmentReport {
    return new StudentKnowledgeDiagnosticAssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: StudentKnowledgeDiagnosticAssessmentReport | PlainMessage<StudentKnowledgeDiagnosticAssessmentReport> | undefined, b: StudentKnowledgeDiagnosticAssessmentReport | PlainMessage<StudentKnowledgeDiagnosticAssessmentReport> | undefined): boolean {
    return proto3.util.equals(StudentKnowledgeDiagnosticAssessmentReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.SubjectTestOverview
 */
export class SubjectTestOverview extends Message<SubjectTestOverview> {
  /**
   * Overall class score percentage
   *
   * @generated from field: float overall_class_score = 1;
   */
  overallClassScore = 0;

  /**
   * Total number of questions
   *
   * @generated from field: int32 number_of_questions = 2;
   */
  numberOfQuestions = 0;

  /**
   * Difficulty level of the test
   *
   * @generated from field: string overall_difficulty_level = 3;
   */
  overallDifficultyLevel = "";

  /**
   * Total possible marks
   *
   * @generated from field: int32 total_marks = 4;
   */
  totalMarks = 0;

  /**
   * Summary of performance
   *
   * @generated from field: string assessment_verdict = 6;
   */
  assessmentVerdict = "";

  /**
   * @generated from field: float student_score = 7;
   */
  studentScore = 0;

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectWiseOverview subject_overview = 8;
   */
  subjectOverview: SubjectWiseOverview[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionDistribution question_distribution = 9;
   */
  questionDistribution: QuestionDistribution[] = [];

  constructor(data?: PartialMessage<SubjectTestOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.SubjectTestOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "overall_class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "overall_difficulty_level", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "assessment_verdict", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "subject_overview", kind: "message", T: SubjectWiseOverview, repeated: true },
    { no: 9, name: "question_distribution", kind: "message", T: QuestionDistribution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectTestOverview {
    return new SubjectTestOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectTestOverview {
    return new SubjectTestOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectTestOverview {
    return new SubjectTestOverview().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectTestOverview | PlainMessage<SubjectTestOverview> | undefined, b: SubjectTestOverview | PlainMessage<SubjectTestOverview> | undefined): boolean {
    return proto3.util.equals(SubjectTestOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.SubjectWiseOverview
 */
export class SubjectWiseOverview extends Message<SubjectWiseOverview> {
  /**
   * Name of the subject (e.g., Maths, Science, English)
   *
   * @generated from field: string subject_name = 1;
   */
  subjectName = "";

  /**
   * @generated from field: optional string section_title = 2;
   */
  sectionTitle?: string;

  /**
   * @generated from field: optional int32 section_no = 3;
   */
  sectionNo?: number;

  /**
   * Total number of questions
   *
   * @generated from field: int32 number_of_questions = 4;
   */
  numberOfQuestions = 0;

  /**
   * Total possible marks
   *
   * @generated from field: int32 total_marks = 5;
   */
  totalMarks = 0;

  /**
   * Total possible marks
   *
   * @generated from field: float marks_achieved = 6;
   */
  marksAchieved = 0;

  /**
   * @generated from field: float percentage_score = 7;
   */
  percentageScore = 0;

  /**
   * @generated from field: float class_coverage = 8;
   */
  classCoverage = 0;

  /**
   * Difficulty level for this subject/section
   *
   * @generated from field: optional string overall_difficulty_level = 9;
   */
  overallDifficultyLevel?: string;

  constructor(data?: PartialMessage<SubjectWiseOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.SubjectWiseOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "number_of_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "marks_achieved", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "percentage_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "class_coverage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "overall_difficulty_level", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectWiseOverview {
    return new SubjectWiseOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectWiseOverview {
    return new SubjectWiseOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectWiseOverview {
    return new SubjectWiseOverview().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectWiseOverview | PlainMessage<SubjectWiseOverview> | undefined, b: SubjectWiseOverview | PlainMessage<SubjectWiseOverview> | undefined): boolean {
    return proto3.util.equals(SubjectWiseOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionDistribution
 */
export class QuestionDistribution extends Message<QuestionDistribution> {
  /**
   * Name of the subject (e.g., Maths, Science, English)
   *
   * @generated from field: string subject_name = 1;
   */
  subjectName = "";

  /**
   * @generated from field: optional string section_title = 2;
   */
  sectionTitle?: string;

  /**
   * @generated from field: optional int32 section_no = 3;
   */
  sectionNo?: number;

  /**
   * Question difficulty distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionDifficultyDistribution question_difficulty_distribution = 4;
   */
  questionDifficultyDistribution?: QuestionDifficultyDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistribution question_bloom_level_distribution = 5;
   */
  questionBloomLevelDistribution?: QuestionBloomLevelDistribution;

  /**
   * Question Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionBloomLevelDistributionV2 question_bloom_level_distribution_v2 = 6;
   */
  questionBloomLevelDistributionV2?: QuestionBloomLevelDistributionV2;

  /**
   * @generated from field: repeated string concepts = 7;
   */
  concepts: string[] = [];

  constructor(data?: PartialMessage<QuestionDistribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionDistribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "question_difficulty_distribution", kind: "message", T: QuestionDifficultyDistribution },
    { no: 5, name: "question_bloom_level_distribution", kind: "message", T: QuestionBloomLevelDistribution },
    { no: 6, name: "question_bloom_level_distribution_v2", kind: "message", T: QuestionBloomLevelDistributionV2 },
    { no: 7, name: "concepts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionDistribution {
    return new QuestionDistribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionDistribution {
    return new QuestionDistribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionDistribution {
    return new QuestionDistribution().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionDistribution | PlainMessage<QuestionDistribution> | undefined, b: QuestionDistribution | PlainMessage<QuestionDistribution> | undefined): boolean {
    return proto3.util.equals(QuestionDistribution, a, b);
  }
}

/**
 * Subject-specific performance report
 *
 * @generated from message geneo.analysis.school.assessment.apis.SubjectReport
 */
export class SubjectReport extends Message<SubjectReport> {
  /**
   * Name of the subject (e.g., Maths, Science, English)
   *
   * @generated from field: string subject_name = 2;
   */
  subjectName = "";

  /**
   * @generated from field: optional string section_title = 3;
   */
  sectionTitle?: string;

  /**
   * @generated from field: optional int32 section_no = 4;
   */
  sectionNo?: number;

  /**
   * Name of the chapter
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.KnowledgeGraph knowledge_graph = 5;
   */
  knowledgeGraph: KnowledgeGraph[] = [];

  /**
   * Performance of questions
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.SubjectQuestionOverview question_overview = 11;
   */
  questionOverview: SubjectQuestionOverview[] = [];

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDown bloom_level_breakdown = 6;
   */
  bloomLevelBreakdown?: BloomLevelBreakDown;

  /**
   * Score Bloom level distribution
   *
   * @generated from field: geneo.analysis.school.assessment.apis.BloomLevelBreakDownV2 bloom_level_breakdown_v2 = 7;
   */
  bloomLevelBreakdownV2?: BloomLevelBreakDownV2;

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.LearningGapsAndRemedy learning_gaps_remedy = 8;
   */
  learningGapsRemedy: LearningGapsAndRemedy[] = [];

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt common_mistakes_remedy = 9;
   */
  commonMistakesRemedy: CommonMistakeAndRemedyKdt[] = [];

  /**
   * V3 additional fields
   *
   * Subject-level performance overview
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.SubjectWiseOverview subject_wise_overview = 12;
   */
  subjectWiseOverview?: SubjectWiseOverview;

  /**
   * LO achievement for this subject
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.LearningOutcomeAchievement learning_outcome_achievement = 13;
   */
  learningOutcomeAchievement?: LearningOutcomeAchievement;

  /**
   * V3-style learning gaps with scores
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.LearningGapRemedyV3 learning_gaps_remedy_v3 = 14;
   */
  learningGapsRemedyV3: LearningGapRemedyV3[] = [];

  /**
   * Per-subject question distribution
   *
   * @generated from field: optional geneo.analysis.school.assessment.apis.QuestionDistribution question_distribution = 15;
   */
  questionDistribution?: QuestionDistribution;

  /**
   * Per-subject student performances
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentPerformance student_performances = 16;
   */
  studentPerformances: StudentPerformance[] = [];

  /**
   * Per-subject focus group and remedy
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.FocusGroupAndRemedy focus_group_and_remedy = 17;
   */
  focusGroupAndRemedy: FocusGroupAndRemedy[] = [];

  constructor(data?: PartialMessage<SubjectReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.SubjectReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "subject_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "knowledge_graph", kind: "message", T: KnowledgeGraph, repeated: true },
    { no: 11, name: "question_overview", kind: "message", T: SubjectQuestionOverview, repeated: true },
    { no: 6, name: "bloom_level_breakdown", kind: "message", T: BloomLevelBreakDown },
    { no: 7, name: "bloom_level_breakdown_v2", kind: "message", T: BloomLevelBreakDownV2 },
    { no: 8, name: "learning_gaps_remedy", kind: "message", T: LearningGapsAndRemedy, repeated: true },
    { no: 9, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedyKdt, repeated: true },
    { no: 12, name: "subject_wise_overview", kind: "message", T: SubjectWiseOverview, opt: true },
    { no: 13, name: "learning_outcome_achievement", kind: "message", T: LearningOutcomeAchievement, opt: true },
    { no: 14, name: "learning_gaps_remedy_v3", kind: "message", T: LearningGapRemedyV3, repeated: true },
    { no: 15, name: "question_distribution", kind: "message", T: QuestionDistribution, opt: true },
    { no: 16, name: "student_performances", kind: "message", T: StudentPerformance, repeated: true },
    { no: 17, name: "focus_group_and_remedy", kind: "message", T: FocusGroupAndRemedy, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectReport {
    return new SubjectReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectReport {
    return new SubjectReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectReport {
    return new SubjectReport().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectReport | PlainMessage<SubjectReport> | undefined, b: SubjectReport | PlainMessage<SubjectReport> | undefined): boolean {
    return proto3.util.equals(SubjectReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.KnowledgeGraph
 */
export class KnowledgeGraph extends Message<KnowledgeGraph> {
  /**
   * @generated from field: string concept = 1;
   */
  concept = "";

  /**
   * @generated from field: float score = 2;
   */
  score = 0;

  /**
   * @generated from field: float ideal_score = 3;
   */
  idealScore = 0;

  /**
   * @generated from field: float class_score = 4;
   */
  classScore = 0;

  /**
   * @generated from field: float min_score = 5;
   */
  minScore = 0;

  constructor(data?: PartialMessage<KnowledgeGraph>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.KnowledgeGraph";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "concept", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "ideal_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "class_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "min_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KnowledgeGraph {
    return new KnowledgeGraph().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KnowledgeGraph {
    return new KnowledgeGraph().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KnowledgeGraph {
    return new KnowledgeGraph().fromJsonString(jsonString, options);
  }

  static equals(a: KnowledgeGraph | PlainMessage<KnowledgeGraph> | undefined, b: KnowledgeGraph | PlainMessage<KnowledgeGraph> | undefined): boolean {
    return proto3.util.equals(KnowledgeGraph, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentHwQuestionOverview
 */
export class StudentHwQuestionOverview extends Message<StudentHwQuestionOverview> {
  /**
   * Question number (e.g., Q1, Q2)
   *
   * @generated from field: int32 question_number = 1;
   */
  questionNumber = 0;

  /**
   * Marks for the question
   *
   * @generated from field: int32 marks = 2;
   */
  marks = 0;

  /**
   * Number of correct answers
   *
   * @generated from field: string chapter = 3;
   */
  chapter = "";

  /**
   * @generated from field: string bloom = 4;
   */
  bloom = "";

  /**
   * Average score percentage
   *
   * @generated from field: float average_score = 5;
   */
  averageScore = 0;

  /**
   * geneo.content.db.DifficultyLevelEnum difficulty_level = 6; // Difficulty level of the question
   *
   * @generated from field: string difficulty = 7;
   */
  difficulty = "";

  /**
   * @generated from field: string learning_outcome = 8;
   */
  learningOutcome = "";

  /**
   * @generated from field: float student_score = 9;
   */
  studentScore = 0;

  /**
   * @generated from field: bool is_attempted = 10;
   */
  isAttempted = false;

  constructor(data?: PartialMessage<StudentHwQuestionOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentHwQuestionOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "chapter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bloom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "average_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "difficulty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentHwQuestionOverview {
    return new StudentHwQuestionOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentHwQuestionOverview {
    return new StudentHwQuestionOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentHwQuestionOverview {
    return new StudentHwQuestionOverview().fromJsonString(jsonString, options);
  }

  static equals(a: StudentHwQuestionOverview | PlainMessage<StudentHwQuestionOverview> | undefined, b: StudentHwQuestionOverview | PlainMessage<StudentHwQuestionOverview> | undefined): boolean {
    return proto3.util.equals(StudentHwQuestionOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.SubjectQuestionOverview
 */
export class SubjectQuestionOverview extends Message<SubjectQuestionOverview> {
  /**
   * Question number (e.g., Q1, Q2)
   *
   * @generated from field: int32 question_number = 1;
   */
  questionNumber = 0;

  /**
   * Marks for the question
   *
   * @generated from field: int32 marks = 2;
   */
  marks = 0;

  /**
   * Concept name
   *
   * @generated from field: string concept = 3;
   */
  concept = "";

  /**
   * @generated from field: string bloom = 4;
   */
  bloom = "";

  /**
   * Average score percentage
   *
   * @generated from field: float average_score = 5;
   */
  averageScore = 0;

  /**
   * geneo.content.db.DifficultyLevelEnum difficulty_level = 6; // Difficulty level of the question
   *
   * @generated from field: string difficulty = 7;
   */
  difficulty = "";

  /**
   * @generated from field: string learning_outcome = 8;
   */
  learningOutcome = "";

  /**
   * @generated from field: float student_score = 9;
   */
  studentScore = 0;

  /**
   * Number of correct answers
   *
   * @generated from field: optional int32 correct_answers = 10;
   */
  correctAnswers?: number;

  /**
   * Number of partially correct answers
   *
   * @generated from field: optional int32 partially_correct_answers = 11;
   */
  partiallyCorrectAnswers?: number;

  constructor(data?: PartialMessage<SubjectQuestionOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.SubjectQuestionOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "concept", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bloom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "average_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "difficulty", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "student_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 11, name: "partially_correct_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectQuestionOverview {
    return new SubjectQuestionOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectQuestionOverview {
    return new SubjectQuestionOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectQuestionOverview {
    return new SubjectQuestionOverview().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectQuestionOverview | PlainMessage<SubjectQuestionOverview> | undefined, b: SubjectQuestionOverview | PlainMessage<SubjectQuestionOverview> | undefined): boolean {
    return proto3.util.equals(SubjectQuestionOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.LearningGapsAndRemedy
 */
export class LearningGapsAndRemedy extends Message<LearningGapsAndRemedy> {
  /**
   * @generated from field: repeated string major_gaps = 1;
   */
  majorGaps: string[] = [];

  /**
   * @generated from field: repeated string minor_gaps = 2;
   */
  minorGaps: string[] = [];

  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ChapterResource chapter_resources = 3;
   */
  chapterResources: ChapterResource[] = [];

  constructor(data?: PartialMessage<LearningGapsAndRemedy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.LearningGapsAndRemedy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "major_gaps", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "minor_gaps", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "chapter_resources", kind: "message", T: ChapterResource, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LearningGapsAndRemedy {
    return new LearningGapsAndRemedy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LearningGapsAndRemedy {
    return new LearningGapsAndRemedy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LearningGapsAndRemedy {
    return new LearningGapsAndRemedy().fromJsonString(jsonString, options);
  }

  static equals(a: LearningGapsAndRemedy | PlainMessage<LearningGapsAndRemedy> | undefined, b: LearningGapsAndRemedy | PlainMessage<LearningGapsAndRemedy> | undefined): boolean {
    return proto3.util.equals(LearningGapsAndRemedy, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ChapterResource
 */
export class ChapterResource extends Message<ChapterResource> {
  /**
   * @generated from field: string chapter_name = 1;
   */
  chapterName = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.ResourceContent resource = 2;
   */
  resource?: ResourceContent;

  constructor(data?: PartialMessage<ChapterResource>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ChapterResource";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource", kind: "message", T: ResourceContent },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterResource {
    return new ChapterResource().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterResource {
    return new ChapterResource().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterResource {
    return new ChapterResource().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterResource | PlainMessage<ChapterResource> | undefined, b: ChapterResource | PlainMessage<ChapterResource> | undefined): boolean {
    return proto3.util.equals(ChapterResource, a, b);
  }
}

/**
 * V3-style learning gap entry with score percentage
 *
 * @generated from message geneo.analysis.school.assessment.apis.LearningGapRemedyV3
 */
export class LearningGapRemedyV3 extends Message<LearningGapRemedyV3> {
  /**
   * LO description text
   *
   * @generated from field: string learning_outcome = 1;
   */
  learningOutcome = "";

  /**
   * Associated concept name
   *
   * @generated from field: optional string concept_name = 2;
   */
  conceptName?: string;

  /**
   * Score percentage achieved
   *
   * @generated from field: float score_percentage = 3;
   */
  scorePercentage = 0;

  /**
   * e.g., "Revise", "Strengthen"
   *
   * @generated from field: string action_required = 4;
   */
  actionRequired = "";

  /**
   * Remediation resources
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ResourceContent remedy_content = 5;
   */
  remedyContent: ResourceContent[] = [];

  constructor(data?: PartialMessage<LearningGapRemedyV3>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.LearningGapRemedyV3";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "concept_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "score_percentage", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "action_required", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "remedy_content", kind: "message", T: ResourceContent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LearningGapRemedyV3 {
    return new LearningGapRemedyV3().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LearningGapRemedyV3 {
    return new LearningGapRemedyV3().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LearningGapRemedyV3 {
    return new LearningGapRemedyV3().fromJsonString(jsonString, options);
  }

  static equals(a: LearningGapRemedyV3 | PlainMessage<LearningGapRemedyV3> | undefined, b: LearningGapRemedyV3 | PlainMessage<LearningGapRemedyV3> | undefined): boolean {
    return proto3.util.equals(LearningGapRemedyV3, a, b);
  }
}

/**
 * Focus group identifying students struggling with specific LOs
 *
 * @generated from message geneo.analysis.school.assessment.apis.FocusGroupAndRemedy
 */
export class FocusGroupAndRemedy extends Message<FocusGroupAndRemedy> {
  /**
   * Student name
   *
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * LOs where this student needs focus
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentFocusArea need_to_focus_areas = 2;
   */
  needToFocusAreas: StudentFocusArea[] = [];

  /**
   * Student's overall score percentage
   *
   * @generated from field: float overall_score = 3;
   */
  overallScore = 0;

  /**
   * Total questions answered incorrectly
   *
   * @generated from field: int32 total_wrong_answers = 4;
   */
  totalWrongAnswers = 0;

  constructor(data?: PartialMessage<FocusGroupAndRemedy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FocusGroupAndRemedy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "need_to_focus_areas", kind: "message", T: StudentFocusArea, repeated: true },
    { no: 3, name: "overall_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_wrong_answers", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FocusGroupAndRemedy {
    return new FocusGroupAndRemedy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FocusGroupAndRemedy {
    return new FocusGroupAndRemedy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FocusGroupAndRemedy {
    return new FocusGroupAndRemedy().fromJsonString(jsonString, options);
  }

  static equals(a: FocusGroupAndRemedy | PlainMessage<FocusGroupAndRemedy> | undefined, b: FocusGroupAndRemedy | PlainMessage<FocusGroupAndRemedy> | undefined): boolean {
    return proto3.util.equals(FocusGroupAndRemedy, a, b);
  }
}

/**
 * Individual focus area for a student
 *
 * @generated from message geneo.analysis.school.assessment.apis.StudentFocusArea
 */
export class StudentFocusArea extends Message<StudentFocusArea> {
  /**
   * LO description text
   *
   * @generated from field: string learning_outcome = 1;
   */
  learningOutcome = "";

  /**
   * Associated concept name
   *
   * @generated from field: optional string concept_name = 2;
   */
  conceptName?: string;

  /**
   * e.g., "Revise", "Critical Revise"
   *
   * @generated from field: string action_required = 3;
   */
  actionRequired = "";

  /**
   * Remediation resources
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.ResourceContent remedy_content = 4;
   */
  remedyContent: ResourceContent[] = [];

  constructor(data?: PartialMessage<StudentFocusArea>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentFocusArea";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "learning_outcome", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "concept_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "action_required", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "remedy_content", kind: "message", T: ResourceContent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentFocusArea {
    return new StudentFocusArea().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentFocusArea {
    return new StudentFocusArea().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentFocusArea {
    return new StudentFocusArea().fromJsonString(jsonString, options);
  }

  static equals(a: StudentFocusArea | PlainMessage<StudentFocusArea> | undefined, b: StudentFocusArea | PlainMessage<StudentFocusArea> | undefined): boolean {
    return proto3.util.equals(StudentFocusArea, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV3Request
 */
export class FetchStudentAssessmentReportV3Request extends Message<FetchStudentAssessmentReportV3Request> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * ID for the student
   *
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * Attempt Number for the student
   *
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * Attempt Type for the student
   *
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportV3Request {
    return new FetchStudentAssessmentReportV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV3Request {
    return new FetchStudentAssessmentReportV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV3Request {
    return new FetchStudentAssessmentReportV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportV3Request | PlainMessage<FetchStudentAssessmentReportV3Request> | undefined, b: FetchStudentAssessmentReportV3Request | PlainMessage<FetchStudentAssessmentReportV3Request> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportV3Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentAssessmentReportDataObject
 */
export class StudentAssessmentReportDataObject extends Message<StudentAssessmentReportDataObject> {
  /**
   * URL for the report stored in GCP
   *
   * @generated from field: optional string gcp_report_url = 1;
   */
  gcpReportUrl?: string;

  /**
   * URL for the summary report stored in GCP
   *
   * @generated from field: optional string gcp_summary_report_url = 2;
   */
  gcpSummaryReportUrl?: string;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<StudentAssessmentReportDataObject>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentAssessmentReportDataObject";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "gcp_summary_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentAssessmentReportDataObject {
    return new StudentAssessmentReportDataObject().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentAssessmentReportDataObject {
    return new StudentAssessmentReportDataObject().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentAssessmentReportDataObject {
    return new StudentAssessmentReportDataObject().fromJsonString(jsonString, options);
  }

  static equals(a: StudentAssessmentReportDataObject | PlainMessage<StudentAssessmentReportDataObject> | undefined, b: StudentAssessmentReportDataObject | PlainMessage<StudentAssessmentReportDataObject> | undefined): boolean {
    return proto3.util.equals(StudentAssessmentReportDataObject, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV3Response
 */
export class FetchStudentAssessmentReportV3Response extends Message<FetchStudentAssessmentReportV3Response> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.StudentAssessmentReportDataObject data = 4;
   */
  data?: StudentAssessmentReportDataObject;

  constructor(data?: PartialMessage<FetchStudentAssessmentReportV3Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentAssessmentReportV3Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentReportDataObject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentAssessmentReportV3Response {
    return new FetchStudentAssessmentReportV3Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV3Response {
    return new FetchStudentAssessmentReportV3Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentAssessmentReportV3Response {
    return new FetchStudentAssessmentReportV3Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentAssessmentReportV3Response | PlainMessage<FetchStudentAssessmentReportV3Response> | undefined, b: FetchStudentAssessmentReportV3Response | PlainMessage<FetchStudentAssessmentReportV3Response> | undefined): boolean {
    return proto3.util.equals(FetchStudentAssessmentReportV3Response, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentJeeAssessmentReport
 */
export class StudentJeeAssessmentReport extends Message<StudentJeeAssessmentReport> {
  /**
   * student user ID
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * student name
   *
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * School name
   *
   * @generated from field: string institute_name = 3;
   */
  instituteName = "";

  /**
   * @generated from field: optional string school_white_label_image_url = 4;
   */
  schoolWhiteLabelImageUrl?: string;

  /**
   * @generated from field: optional int32 school_id = 5;
   */
  schoolId?: number;

  /**
   * List of chapters
   *
   * @generated from field: repeated string unit_name = 6;
   */
  unitName: string[] = [];

  /**
   * test date
   *
   * @generated from field: google.protobuf.Timestamp test_date = 7;
   */
  testDate?: Timestamp;

  /**
   * List of assessments
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.AssessmentData assessments = 8;
   */
  assessments: AssessmentData[] = [];

  /**
   * @generated from field: optional int32 attempt_number = 9;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 10;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<StudentJeeAssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentJeeAssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "institute_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "school_white_label_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "test_date", kind: "message", T: Timestamp },
    { no: 8, name: "assessments", kind: "message", T: AssessmentData, repeated: true },
    { no: 9, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 10, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentJeeAssessmentReport {
    return new StudentJeeAssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentJeeAssessmentReport {
    return new StudentJeeAssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentJeeAssessmentReport {
    return new StudentJeeAssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: StudentJeeAssessmentReport | PlainMessage<StudentJeeAssessmentReport> | undefined, b: StudentJeeAssessmentReport | PlainMessage<StudentJeeAssessmentReport> | undefined): boolean {
    return proto3.util.equals(StudentJeeAssessmentReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.AssessmentData
 */
export class AssessmentData extends Message<AssessmentData> {
  /**
   * assessmentId
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * Name of the subject
   *
   * @generated from field: string subject = 2;
   */
  subject = "";

  /**
   * @generated from field: optional int32 section_no = 3;
   */
  sectionNo?: number;

  /**
   * @generated from field: optional string section_title = 4;
   */
  sectionTitle?: string;

  /**
   * overview of the assessment
   *
   * @generated from field: geneo.analysis.school.assessment.apis.Overview overview = 5;
   */
  overview?: Overview;

  /**
   * question attempt analysis
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionAttemptAnalysis question_attempt_analysis = 6;
   */
  questionAttemptAnalysis?: QuestionAttemptAnalysis;

  /**
   * topic score comparison
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.TopicScoreComparison topic_score_comparison = 7;
   */
  topicScoreComparison: TopicScoreComparison[] = [];

  /**
   * Name of the chapter
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.KnowledgeGraph knowledge_graph = 8;
   */
  knowledgeGraph: KnowledgeGraph[] = [];

  /**
   * List of chapters
   *
   * @generated from field: repeated string strengths = 9;
   */
  strengths: string[] = [];

  /**
   * List of chapters
   *
   * @generated from field: repeated string growth_areas = 10;
   */
  growthAreas: string[] = [];

  /**
   * performance breakdown of the assessment
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.PerformanceBreakdown performance_breakdown = 11;
   */
  performanceBreakdown: PerformanceBreakdown[] = [];

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt common_mistakes_remedy = 12;
   */
  commonMistakesRemedy: CommonMistakeAndRemedyKdt[] = [];

  constructor(data?: PartialMessage<AssessmentData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.AssessmentData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "overview", kind: "message", T: Overview },
    { no: 6, name: "question_attempt_analysis", kind: "message", T: QuestionAttemptAnalysis },
    { no: 7, name: "topic_score_comparison", kind: "message", T: TopicScoreComparison, repeated: true },
    { no: 8, name: "knowledge_graph", kind: "message", T: KnowledgeGraph, repeated: true },
    { no: 9, name: "strengths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "growth_areas", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "performance_breakdown", kind: "message", T: PerformanceBreakdown, repeated: true },
    { no: 12, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedyKdt, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentData {
    return new AssessmentData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentData {
    return new AssessmentData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentData {
    return new AssessmentData().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentData | PlainMessage<AssessmentData> | undefined, b: AssessmentData | PlainMessage<AssessmentData> | undefined): boolean {
    return proto3.util.equals(AssessmentData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.Overview
 */
export class Overview extends Message<Overview> {
  /**
   * Total number of questions
   *
   * @generated from field: int32 total_questions = 1;
   */
  totalQuestions = 0;

  /**
   * Total marks
   *
   * @generated from field: int32 total_marks = 2;
   */
  totalMarks = 0;

  /**
   * marks achieved
   *
   * @generated from field: int32 marks_achieved = 3;
   */
  marksAchieved = 0;

  /**
   * scores
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.StudentScore scores = 4;
   */
  scores: StudentScore[] = [];

  /**
   * total ideal time in mins
   *
   * @generated from field: int32 ideal_time_in_mins = 5;
   */
  idealTimeInMins = 0;

  constructor(data?: PartialMessage<Overview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.Overview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "marks_achieved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "scores", kind: "message", T: StudentScore, repeated: true },
    { no: 5, name: "ideal_time_in_mins", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Overview {
    return new Overview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Overview {
    return new Overview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Overview {
    return new Overview().fromJsonString(jsonString, options);
  }

  static equals(a: Overview | PlainMessage<Overview> | undefined, b: Overview | PlainMessage<Overview> | undefined): boolean {
    return proto3.util.equals(Overview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StudentScore
 */
export class StudentScore extends Message<StudentScore> {
  /**
   * student user ID
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * score percentage
   *
   * @generated from field: double score_percent = 2;
   */
  scorePercent = 0;

  /**
   * time taken by student in mins
   *
   * @generated from field: int32 time_taken_in_mins = 3;
   */
  timeTakenInMins = 0;

  constructor(data?: PartialMessage<StudentScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StudentScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "score_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "time_taken_in_mins", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentScore {
    return new StudentScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentScore {
    return new StudentScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentScore {
    return new StudentScore().fromJsonString(jsonString, options);
  }

  static equals(a: StudentScore | PlainMessage<StudentScore> | undefined, b: StudentScore | PlainMessage<StudentScore> | undefined): boolean {
    return proto3.util.equals(StudentScore, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionAttemptAnalysis
 */
export class QuestionAttemptAnalysis extends Message<QuestionAttemptAnalysis> {
  /**
   * summary of attempted questions
   *
   * @generated from field: geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisSummary summary = 1;
   */
  summary?: QuestionAttemptAnalysisSummary;

  /**
   * summary of questions topic wise
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisTopic topics = 2;
   */
  topics: QuestionAttemptAnalysisTopic[] = [];

  constructor(data?: PartialMessage<QuestionAttemptAnalysis>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionAttemptAnalysis";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "summary", kind: "message", T: QuestionAttemptAnalysisSummary },
    { no: 2, name: "topics", kind: "message", T: QuestionAttemptAnalysisTopic, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionAttemptAnalysis {
    return new QuestionAttemptAnalysis().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysis {
    return new QuestionAttemptAnalysis().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysis {
    return new QuestionAttemptAnalysis().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionAttemptAnalysis | PlainMessage<QuestionAttemptAnalysis> | undefined, b: QuestionAttemptAnalysis | PlainMessage<QuestionAttemptAnalysis> | undefined): boolean {
    return proto3.util.equals(QuestionAttemptAnalysis, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisSummary
 */
export class QuestionAttemptAnalysisSummary extends Message<QuestionAttemptAnalysisSummary> {
  /**
   * total number of correct questions
   *
   * @generated from field: int32 correct = 1;
   */
  correct = 0;

  /**
   * total number of incorrect questions
   *
   * @generated from field: int32 incorrect = 2;
   */
  incorrect = 0;

  /**
   * total number of unattempted questions
   *
   * @generated from field: int32 unattempted = 3;
   */
  unattempted = 0;

  /**
   * total correct percentage
   *
   * @generated from field: double correct_percent = 4;
   */
  correctPercent = 0;

  /**
   * total incorrect percentage
   *
   * @generated from field: double incorrect_percent = 5;
   */
  incorrectPercent = 0;

  /**
   * total unattempted percentage
   *
   * @generated from field: double unattempted_percent = 6;
   */
  unattemptedPercent = 0;

  constructor(data?: PartialMessage<QuestionAttemptAnalysisSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "incorrect", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "unattempted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "correct_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "incorrect_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "unattempted_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionAttemptAnalysisSummary {
    return new QuestionAttemptAnalysisSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysisSummary {
    return new QuestionAttemptAnalysisSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysisSummary {
    return new QuestionAttemptAnalysisSummary().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionAttemptAnalysisSummary | PlainMessage<QuestionAttemptAnalysisSummary> | undefined, b: QuestionAttemptAnalysisSummary | PlainMessage<QuestionAttemptAnalysisSummary> | undefined): boolean {
    return proto3.util.equals(QuestionAttemptAnalysisSummary, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisTopic
 */
export class QuestionAttemptAnalysisTopic extends Message<QuestionAttemptAnalysisTopic> {
  /**
   * Name of the topic
   *
   * @generated from field: string topic = 1;
   */
  topic = "";

  /**
   * total number of questions
   *
   * @generated from field: int32 total_questions = 2;
   */
  totalQuestions = 0;

  /**
   * total number of questions attempted
   *
   * @generated from field: int32 attempted = 3;
   */
  attempted = 0;

  /**
   * total number of correct questions
   *
   * @generated from field: int32 correct = 4;
   */
  correct = 0;

  /**
   * total number of incorrect questions
   *
   * @generated from field: int32 incorrect = 5;
   */
  incorrect = 0;

  /**
   * total marks achieved
   *
   * @generated from field: double marks_achieved = 6;
   */
  marksAchieved = 0;

  /**
   * total marks
   *
   * @generated from field: double total_marks = 7;
   */
  totalMarks = 0;

  /**
   * total percentage
   *
   * @generated from field: double percent = 8;
   */
  percent = 0;

  constructor(data?: PartialMessage<QuestionAttemptAnalysisTopic>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionAttemptAnalysisTopic";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "attempted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "incorrect", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "marks_achieved", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "total_marks", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionAttemptAnalysisTopic {
    return new QuestionAttemptAnalysisTopic().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysisTopic {
    return new QuestionAttemptAnalysisTopic().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionAttemptAnalysisTopic {
    return new QuestionAttemptAnalysisTopic().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionAttemptAnalysisTopic | PlainMessage<QuestionAttemptAnalysisTopic> | undefined, b: QuestionAttemptAnalysisTopic | PlainMessage<QuestionAttemptAnalysisTopic> | undefined): boolean {
    return proto3.util.equals(QuestionAttemptAnalysisTopic, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TopicScoreComparison
 */
export class TopicScoreComparison extends Message<TopicScoreComparison> {
  /**
   * Name of the topic
   *
   * @generated from field: string topic = 1;
   */
  topic = "";

  /**
   * topic wise student scores
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.TopicWiseStudentScore scores = 2;
   */
  scores: TopicWiseStudentScore[] = [];

  constructor(data?: PartialMessage<TopicScoreComparison>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TopicScoreComparison";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scores", kind: "message", T: TopicWiseStudentScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopicScoreComparison {
    return new TopicScoreComparison().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopicScoreComparison {
    return new TopicScoreComparison().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopicScoreComparison {
    return new TopicScoreComparison().fromJsonString(jsonString, options);
  }

  static equals(a: TopicScoreComparison | PlainMessage<TopicScoreComparison> | undefined, b: TopicScoreComparison | PlainMessage<TopicScoreComparison> | undefined): boolean {
    return proto3.util.equals(TopicScoreComparison, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TopicWiseStudentScore
 */
export class TopicWiseStudentScore extends Message<TopicWiseStudentScore> {
  /**
   * student user ID
   *
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * total percentage
   *
   * @generated from field: double score_percent = 2;
   */
  scorePercent = 0;

  constructor(data?: PartialMessage<TopicWiseStudentScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TopicWiseStudentScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "score_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopicWiseStudentScore {
    return new TopicWiseStudentScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopicWiseStudentScore {
    return new TopicWiseStudentScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopicWiseStudentScore {
    return new TopicWiseStudentScore().fromJsonString(jsonString, options);
  }

  static equals(a: TopicWiseStudentScore | PlainMessage<TopicWiseStudentScore> | undefined, b: TopicWiseStudentScore | PlainMessage<TopicWiseStudentScore> | undefined): boolean {
    return proto3.util.equals(TopicWiseStudentScore, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.PerformanceBreakdown
 */
export class PerformanceBreakdown extends Message<PerformanceBreakdown> {
  /**
   * question number
   *
   * @generated from field: int32 qNo = 1;
   */
  qNo = 0;

  /**
   * Name of the topic
   *
   * @generated from field: string topic = 2;
   */
  topic = "";

  /**
   * correct answer of the question
   *
   * @generated from field: string correct_answer = 3;
   */
  correctAnswer = "";

  /**
   * answer given by the student
   *
   * @generated from field: string your_answer = 4;
   */
  yourAnswer = "";

  /**
   * total percentage
   *
   * @generated from field: double score_percent = 5;
   */
  scorePercent = 0;

  /**
   * time taken by student
   *
   * @generated from field: int32 time_sec = 6;
   */
  timeSec = 0;

  /**
   * total percentage
   *
   * @generated from field: double avg_score_percent = 7;
   */
  avgScorePercent = 0;

  constructor(data?: PartialMessage<PerformanceBreakdown>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.PerformanceBreakdown";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "qNo", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "correct_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "your_answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "score_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "time_sec", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "avg_score_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PerformanceBreakdown {
    return new PerformanceBreakdown().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PerformanceBreakdown {
    return new PerformanceBreakdown().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PerformanceBreakdown {
    return new PerformanceBreakdown().fromJsonString(jsonString, options);
  }

  static equals(a: PerformanceBreakdown | PlainMessage<PerformanceBreakdown> | undefined, b: PerformanceBreakdown | PlainMessage<PerformanceBreakdown> | undefined): boolean {
    return proto3.util.equals(PerformanceBreakdown, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReport
 */
export class TeacherJeeAssessmentReport extends Message<TeacherJeeAssessmentReport> {
  /**
   * Meta information
   *
   * @generated from field: geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportMeta meta = 1;
   */
  meta?: TeacherJeeAssessmentReportMeta;

  /**
   * Overall information only related to MultiSubject
   *
   * @generated from field: geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportOverallData overall = 2;
   */
  overall?: TeacherJeeAssessmentReportOverallData;

  /**
   * List of assessments
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.TeacherJeeReportAssessmentData assessments = 3;
   */
  assessments: TeacherJeeReportAssessmentData[] = [];

  constructor(data?: PartialMessage<TeacherJeeAssessmentReport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "meta", kind: "message", T: TeacherJeeAssessmentReportMeta },
    { no: 2, name: "overall", kind: "message", T: TeacherJeeAssessmentReportOverallData },
    { no: 3, name: "assessments", kind: "message", T: TeacherJeeReportAssessmentData, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherJeeAssessmentReport {
    return new TeacherJeeAssessmentReport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReport {
    return new TeacherJeeAssessmentReport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReport {
    return new TeacherJeeAssessmentReport().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherJeeAssessmentReport | PlainMessage<TeacherJeeAssessmentReport> | undefined, b: TeacherJeeAssessmentReport | PlainMessage<TeacherJeeAssessmentReport> | undefined): boolean {
    return proto3.util.equals(TeacherJeeAssessmentReport, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportMeta
 */
export class TeacherJeeAssessmentReportMeta extends Message<TeacherJeeAssessmentReportMeta> {
  /**
   * School name
   *
   * @generated from field: string school_name = 1;
   */
  schoolName = "";

  /**
   * Class name
   *
   * @generated from field: string class = 2;
   */
  class = "";

  /**
   * Batch
   *
   * @generated from field: string batch = 3;
   */
  batch = "";

  /**
   * Test date
   *
   * @generated from field: google.protobuf.Timestamp date = 4;
   */
  date?: Timestamp;

  /**
   * Assessment type
   *
   * @generated from field: string assessment_type = 5;
   */
  assessmentType = "";

  /**
   * Total students
   *
   * @generated from field: int32 students_assessed = 6;
   */
  studentsAssessed = 0;

  /**
   * @generated from field: optional int32 attempt_number = 7;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 8;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<TeacherJeeAssessmentReportMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "school_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "batch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "date", kind: "message", T: Timestamp },
    { no: 5, name: "assessment_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "students_assessed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 8, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherJeeAssessmentReportMeta {
    return new TeacherJeeAssessmentReportMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReportMeta {
    return new TeacherJeeAssessmentReportMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReportMeta {
    return new TeacherJeeAssessmentReportMeta().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherJeeAssessmentReportMeta | PlainMessage<TeacherJeeAssessmentReportMeta> | undefined, b: TeacherJeeAssessmentReportMeta | PlainMessage<TeacherJeeAssessmentReportMeta> | undefined): boolean {
    return proto3.util.equals(TeacherJeeAssessmentReportMeta, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TeacherJeeReportAssessmentData
 */
export class TeacherJeeReportAssessmentData extends Message<TeacherJeeReportAssessmentData> {
  /**
   * Name of the subject
   *
   * @generated from field: string subject = 1;
   */
  subject = "";

  /**
   * List of chapters
   *
   * @generated from field: repeated string unit_name = 2;
   */
  unitName: string[] = [];

  /**
   * Section no
   *
   * @generated from field: optional int32 section_no = 3;
   */
  sectionNo?: number;

  /**
   * Section title
   *
   * @generated from field: optional string section_title = 4;
   */
  sectionTitle?: string;

  /**
   * Test overview of the assessment
   *
   * @generated from field: geneo.analysis.school.assessment.apis.JeeReportTestOverview test_overview = 5;
   */
  testOverview?: JeeReportTestOverview;

  /**
   * Question wise performance
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.QuestionWisePerformance question_wise_performance = 6;
   */
  questionWisePerformance: QuestionWisePerformance[] = [];

  /**
   * Students information
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.JeeReportStudent students = 7;
   */
  students: JeeReportStudent[] = [];

  /**
   * Topic wise comparison
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.TopicWiseComparison topic_wise_comparison = 8;
   */
  topicWiseComparison: TopicWiseComparison[] = [];

  /**
   * Strengths And Growth
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StrengthsAndGrowth strengths_and_growth = 9;
   */
  strengthsAndGrowth?: StrengthsAndGrowth;

  /**
   * Common mistakes and remedies
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.CommonMistakeAndRemedyKdt common_mistakes_remedy = 10;
   */
  commonMistakesRemedy: CommonMistakeAndRemedyKdt[] = [];

  /**
   * List of recommendations
   *
   * @generated from field: repeated string recommendations = 11;
   */
  recommendations: string[] = [];

  constructor(data?: PartialMessage<TeacherJeeReportAssessmentData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TeacherJeeReportAssessmentData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unit_name", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "section_no", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "section_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "test_overview", kind: "message", T: JeeReportTestOverview },
    { no: 6, name: "question_wise_performance", kind: "message", T: QuestionWisePerformance, repeated: true },
    { no: 7, name: "students", kind: "message", T: JeeReportStudent, repeated: true },
    { no: 8, name: "topic_wise_comparison", kind: "message", T: TopicWiseComparison, repeated: true },
    { no: 9, name: "strengths_and_growth", kind: "message", T: StrengthsAndGrowth },
    { no: 10, name: "common_mistakes_remedy", kind: "message", T: CommonMistakeAndRemedyKdt, repeated: true },
    { no: 11, name: "recommendations", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherJeeReportAssessmentData {
    return new TeacherJeeReportAssessmentData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherJeeReportAssessmentData {
    return new TeacherJeeReportAssessmentData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherJeeReportAssessmentData {
    return new TeacherJeeReportAssessmentData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherJeeReportAssessmentData | PlainMessage<TeacherJeeReportAssessmentData> | undefined, b: TeacherJeeReportAssessmentData | PlainMessage<TeacherJeeReportAssessmentData> | undefined): boolean {
    return proto3.util.equals(TeacherJeeReportAssessmentData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.JeeReportTestOverview
 */
export class JeeReportTestOverview extends Message<JeeReportTestOverview> {
  /**
   * Total questions
   *
   * @generated from field: int32 total_questions = 1;
   */
  totalQuestions = 0;

  /**
   * Class average percentage
   *
   * @generated from field: double class_average_percent = 2;
   */
  classAveragePercent = 0;

  /**
   * Total score
   *
   * @generated from field: optional int32 score = 3;
   */
  score?: number;

  /**
   * Total max score
   *
   * @generated from field: int32 max_score = 4;
   */
  maxScore = 0;

  /**
   * Assessment verdict
   *
   * @generated from field: optional string assessment_verdict = 5;
   */
  assessmentVerdict?: string;

  constructor(data?: PartialMessage<JeeReportTestOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.JeeReportTestOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "class_average_percent", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "score", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "max_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "assessment_verdict", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JeeReportTestOverview {
    return new JeeReportTestOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JeeReportTestOverview {
    return new JeeReportTestOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JeeReportTestOverview {
    return new JeeReportTestOverview().fromJsonString(jsonString, options);
  }

  static equals(a: JeeReportTestOverview | PlainMessage<JeeReportTestOverview> | undefined, b: JeeReportTestOverview | PlainMessage<JeeReportTestOverview> | undefined): boolean {
    return proto3.util.equals(JeeReportTestOverview, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.QuestionWisePerformance
 */
export class QuestionWisePerformance extends Message<QuestionWisePerformance> {
  /**
   * Question Id
   *
   * @generated from field: string questionId = 1;
   */
  questionId = "";

  /**
   * Question number
   *
   * @generated from field: int32 question_no = 2;
   */
  questionNo = 0;

  /**
   * Name of the concept
   *
   * @generated from field: string topic = 3;
   */
  topic = "";

  /**
   * Total number of correct questions
   *
   * @generated from field: int32 correct = 4;
   */
  correct = 0;

  /**
   * Total number of wrong questions
   *
   * @generated from field: int32 wrong = 5;
   */
  wrong = 0;

  /**
   * Total number of unattempted questions
   *
   * @generated from field: int32 unattempted = 6;
   */
  unattempted = 0;

  /**
   * Average percentage
   *
   * @generated from field: int32 avg_percent = 7;
   */
  avgPercent = 0;

  /**
   * Accuracy percentage
   *
   * @generated from field: int32 accuracy = 8;
   */
  accuracy = 0;

  /**
   * Total time taken
   *
   * @generated from field: int32 avg_time_sec = 9;
   */
  avgTimeSec = 0;

  constructor(data?: PartialMessage<QuestionWisePerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.QuestionWisePerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "questionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "question_no", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "wrong", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "unattempted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "avg_percent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "accuracy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "avg_time_sec", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuestionWisePerformance {
    return new QuestionWisePerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuestionWisePerformance {
    return new QuestionWisePerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuestionWisePerformance {
    return new QuestionWisePerformance().fromJsonString(jsonString, options);
  }

  static equals(a: QuestionWisePerformance | PlainMessage<QuestionWisePerformance> | undefined, b: QuestionWisePerformance | PlainMessage<QuestionWisePerformance> | undefined): boolean {
    return proto3.util.equals(QuestionWisePerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.JeeReportStudent
 */
export class JeeReportStudent extends Message<JeeReportStudent> {
  /**
   * Student name
   *
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * Student metrics
   *
   * @generated from field: geneo.analysis.school.assessment.apis.Metrics metrics = 2;
   */
  metrics?: Metrics;

  /**
   * Student attempt stats
   *
   * @generated from field: geneo.analysis.school.assessment.apis.AttemptStats attempt_stats = 3;
   */
  attemptStats?: AttemptStats;

  /**
   * Student negative marking
   *
   * @generated from field: geneo.analysis.school.assessment.apis.NegativeMarking negative_marking = 4;
   */
  negativeMarking?: NegativeMarking;

  /**
   * Student weak topics
   *
   * @generated from field: repeated string weak_topics = 5;
   */
  weakTopics: string[] = [];

  /**
   * Student responses
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.Responses responses = 6;
   */
  responses: Responses[] = [];

  constructor(data?: PartialMessage<JeeReportStudent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.JeeReportStudent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metrics", kind: "message", T: Metrics },
    { no: 3, name: "attempt_stats", kind: "message", T: AttemptStats },
    { no: 4, name: "negative_marking", kind: "message", T: NegativeMarking },
    { no: 5, name: "weak_topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "responses", kind: "message", T: Responses, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JeeReportStudent {
    return new JeeReportStudent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JeeReportStudent {
    return new JeeReportStudent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JeeReportStudent {
    return new JeeReportStudent().fromJsonString(jsonString, options);
  }

  static equals(a: JeeReportStudent | PlainMessage<JeeReportStudent> | undefined, b: JeeReportStudent | PlainMessage<JeeReportStudent> | undefined): boolean {
    return proto3.util.equals(JeeReportStudent, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.Metrics
 */
export class Metrics extends Message<Metrics> {
  /**
   * Student score
   *
   * @generated from field: int32 score = 1;
   */
  score = 0;

  /**
   * Student accuracy
   *
   * @generated from field: int32 accuracy = 2;
   */
  accuracy = 0;

  /**
   * Student percentile
   *
   * @generated from field: int32 percentile = 3;
   */
  percentile = 0;

  /**
   * Student total time taken
   *
   * @generated from field: int32 time_taken = 4;
   */
  timeTaken = 0;

  constructor(data?: PartialMessage<Metrics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.Metrics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "accuracy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "percentile", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "time_taken", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Metrics {
    return new Metrics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Metrics {
    return new Metrics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Metrics {
    return new Metrics().fromJsonString(jsonString, options);
  }

  static equals(a: Metrics | PlainMessage<Metrics> | undefined, b: Metrics | PlainMessage<Metrics> | undefined): boolean {
    return proto3.util.equals(Metrics, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.AttemptStats
 */
export class AttemptStats extends Message<AttemptStats> {
  /**
   * Total number of correct questions
   *
   * @generated from field: int32 correct = 1;
   */
  correct = 0;

  /**
   * Total number of wrong questions
   *
   * @generated from field: int32 wrong = 2;
   */
  wrong = 0;

  /**
   * Total number of unattempted questions
   *
   * @generated from field: int32 unattempted = 3;
   */
  unattempted = 0;

  constructor(data?: PartialMessage<AttemptStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.AttemptStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "wrong", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "unattempted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttemptStats {
    return new AttemptStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttemptStats {
    return new AttemptStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttemptStats {
    return new AttemptStats().fromJsonString(jsonString, options);
  }

  static equals(a: AttemptStats | PlainMessage<AttemptStats> | undefined, b: AttemptStats | PlainMessage<AttemptStats> | undefined): boolean {
    return proto3.util.equals(AttemptStats, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.NegativeMarking
 */
export class NegativeMarking extends Message<NegativeMarking> {
  /**
   * Gross marks
   *
   * @generated from field: int32 gross_marks = 1;
   */
  grossMarks = 0;

  /**
   * Marks lost
   *
   * @generated from field: int32 marks_lost = 2;
   */
  marksLost = 0;

  /**
   * Net score
   *
   * @generated from field: int32 net_score = 3;
   */
  netScore = 0;

  constructor(data?: PartialMessage<NegativeMarking>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.NegativeMarking";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gross_marks", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "marks_lost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "net_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NegativeMarking {
    return new NegativeMarking().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NegativeMarking {
    return new NegativeMarking().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NegativeMarking {
    return new NegativeMarking().fromJsonString(jsonString, options);
  }

  static equals(a: NegativeMarking | PlainMessage<NegativeMarking> | undefined, b: NegativeMarking | PlainMessage<NegativeMarking> | undefined): boolean {
    return proto3.util.equals(NegativeMarking, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.Responses
 */
export class Responses extends Message<Responses> {
  /**
   * Question number
   *
   * @generated from field: int32 qNo = 1;
   */
  qNo = 0;

  /**
   * Answer given by the student
   *
   * @generated from field: string status = 4;
   */
  status = "";

  constructor(data?: PartialMessage<Responses>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.Responses";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "qNo", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Responses {
    return new Responses().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Responses {
    return new Responses().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Responses {
    return new Responses().fromJsonString(jsonString, options);
  }

  static equals(a: Responses | PlainMessage<Responses> | undefined, b: Responses | PlainMessage<Responses> | undefined): boolean {
    return proto3.util.equals(Responses, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TopicWiseComparison
 */
export class TopicWiseComparison extends Message<TopicWiseComparison> {
  /**
   * Name of the concept
   *
   * @generated from field: string topic = 1;
   */
  topic = "";

  /**
   * Class average
   *
   * @generated from field: int32 class_avg = 2;
   */
  classAvg = 0;

  /**
   * Average percentage
   *
   * @generated from field: int32 accuracy = 3;
   */
  accuracy = 0;

  /**
   * Accuracy percentage
   *
   * @generated from field: int32 attempt_rate = 4;
   */
  attemptRate = 0;

  /**
   * Topic wise student scores
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.TopicWiseStudentScore scores = 5;
   */
  scores: TopicWiseStudentScore[] = [];

  constructor(data?: PartialMessage<TopicWiseComparison>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TopicWiseComparison";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "class_avg", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "accuracy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "attempt_rate", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "scores", kind: "message", T: TopicWiseStudentScore, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopicWiseComparison {
    return new TopicWiseComparison().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopicWiseComparison {
    return new TopicWiseComparison().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopicWiseComparison {
    return new TopicWiseComparison().fromJsonString(jsonString, options);
  }

  static equals(a: TopicWiseComparison | PlainMessage<TopicWiseComparison> | undefined, b: TopicWiseComparison | PlainMessage<TopicWiseComparison> | undefined): boolean {
    return proto3.util.equals(TopicWiseComparison, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.StrengthsAndGrowth
 */
export class StrengthsAndGrowth extends Message<StrengthsAndGrowth> {
  /**
   * List of concepts
   *
   * @generated from field: repeated string strengths = 9;
   */
  strengths: string[] = [];

  /**
   * List of concepts
   *
   * @generated from field: repeated string growth_areas = 10;
   */
  growthAreas: string[] = [];

  constructor(data?: PartialMessage<StrengthsAndGrowth>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.StrengthsAndGrowth";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 9, name: "strengths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "growth_areas", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StrengthsAndGrowth {
    return new StrengthsAndGrowth().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StrengthsAndGrowth {
    return new StrengthsAndGrowth().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StrengthsAndGrowth {
    return new StrengthsAndGrowth().fromJsonString(jsonString, options);
  }

  static equals(a: StrengthsAndGrowth | PlainMessage<StrengthsAndGrowth> | undefined, b: StrengthsAndGrowth | PlainMessage<StrengthsAndGrowth> | undefined): boolean {
    return proto3.util.equals(StrengthsAndGrowth, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentOMRKdtAssessmentReportRequest
 */
export class FetchStudentOMRKdtAssessmentReportRequest extends Message<FetchStudentOMRKdtAssessmentReportRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: optional string roll_number = 2;
   */
  rollNumber?: string;

  /**
   * @generated from field: optional int32 class = 3;
   */
  class?: number;

  /**
   * @generated from field: optional string section = 4;
   */
  section?: string;

  /**
   * @generated from field: optional int32 school_id = 5;
   */
  schoolId?: number;

  /**
   * @generated from field: optional string student_id = 6;
   */
  studentId?: string;

  constructor(data?: PartialMessage<FetchStudentOMRKdtAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentOMRKdtAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "class", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentOMRKdtAssessmentReportRequest {
    return new FetchStudentOMRKdtAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentOMRKdtAssessmentReportRequest {
    return new FetchStudentOMRKdtAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentOMRKdtAssessmentReportRequest {
    return new FetchStudentOMRKdtAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentOMRKdtAssessmentReportRequest | PlainMessage<FetchStudentOMRKdtAssessmentReportRequest> | undefined, b: FetchStudentOMRKdtAssessmentReportRequest | PlainMessage<FetchStudentOMRKdtAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchStudentOMRKdtAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentOMRKdtPdfRequest
 */
export class updateStudentOMRKdtPdfRequest extends Message<updateStudentOMRKdtPdfRequest> {
  /**
   * @generated from field: int64 homeworkId = 1;
   */
  homeworkId = protoInt64.zero;

  /**
   * @generated from field: string gcp_report_url = 2;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  /**
   * @generated from field: string student_id = 4;
   */
  studentId = "";

  /**
   * @generated from field: int32 class_number = 5;
   */
  classNumber = 0;

  /**
   * @generated from field: string section = 6;
   */
  section = "";

  /**
   * @generated from field: int32 school_id = 7;
   */
  schoolId = 0;

  constructor(data?: PartialMessage<updateStudentOMRKdtPdfRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentOMRKdtPdfRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "homeworkId", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
    { no: 4, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "class_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentOMRKdtPdfRequest {
    return new updateStudentOMRKdtPdfRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentOMRKdtPdfRequest {
    return new updateStudentOMRKdtPdfRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentOMRKdtPdfRequest {
    return new updateStudentOMRKdtPdfRequest().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentOMRKdtPdfRequest | PlainMessage<updateStudentOMRKdtPdfRequest> | undefined, b: updateStudentOMRKdtPdfRequest | PlainMessage<updateStudentOMRKdtPdfRequest> | undefined): boolean {
    return proto3.util.equals(updateStudentOMRKdtPdfRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.updateStudentHwPdfResponse
 */
export class updateStudentHwPdfResponse extends Message<updateStudentHwPdfResponse> {
  constructor(data?: PartialMessage<updateStudentHwPdfResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.updateStudentHwPdfResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): updateStudentHwPdfResponse {
    return new updateStudentHwPdfResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): updateStudentHwPdfResponse {
    return new updateStudentHwPdfResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): updateStudentHwPdfResponse {
    return new updateStudentHwPdfResponse().fromJsonString(jsonString, options);
  }

  static equals(a: updateStudentHwPdfResponse | PlainMessage<updateStudentHwPdfResponse> | undefined, b: updateStudentHwPdfResponse | PlainMessage<updateStudentHwPdfResponse> | undefined): boolean {
    return proto3.util.equals(updateStudentHwPdfResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ImportOmrResponsesRequest
 */
export class ImportOmrResponsesRequest extends Message<ImportOmrResponsesRequest> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp date_of_assessment = 2;
   */
  dateOfAssessment?: Timestamp;

  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload files_info = 3;
   */
  filesInfo: CloudUpload[] = [];

  constructor(data?: PartialMessage<ImportOmrResponsesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ImportOmrResponsesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "date_of_assessment", kind: "message", T: Timestamp },
    { no: 3, name: "files_info", kind: "message", T: CloudUpload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportOmrResponsesRequest {
    return new ImportOmrResponsesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportOmrResponsesRequest {
    return new ImportOmrResponsesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportOmrResponsesRequest {
    return new ImportOmrResponsesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportOmrResponsesRequest | PlainMessage<ImportOmrResponsesRequest> | undefined, b: ImportOmrResponsesRequest | PlainMessage<ImportOmrResponsesRequest> | undefined): boolean {
    return proto3.util.equals(ImportOmrResponsesRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ImportOmrResponsesData
 */
export class ImportOmrResponsesData extends Message<ImportOmrResponsesData> {
  /**
   * @generated from field: repeated geneo.lms.db.CloudUpload files_info = 1;
   */
  filesInfo: CloudUpload[] = [];

  constructor(data?: PartialMessage<ImportOmrResponsesData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ImportOmrResponsesData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "files_info", kind: "message", T: CloudUpload, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportOmrResponsesData {
    return new ImportOmrResponsesData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportOmrResponsesData {
    return new ImportOmrResponsesData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportOmrResponsesData {
    return new ImportOmrResponsesData().fromJsonString(jsonString, options);
  }

  static equals(a: ImportOmrResponsesData | PlainMessage<ImportOmrResponsesData> | undefined, b: ImportOmrResponsesData | PlainMessage<ImportOmrResponsesData> | undefined): boolean {
    return proto3.util.equals(ImportOmrResponsesData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.ImportOmrResponsesResponse
 */
export class ImportOmrResponsesResponse extends Message<ImportOmrResponsesResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.ImportOmrResponsesData data = 4;
   */
  data?: ImportOmrResponsesData;

  constructor(data?: PartialMessage<ImportOmrResponsesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.ImportOmrResponsesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: ImportOmrResponsesData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportOmrResponsesResponse {
    return new ImportOmrResponsesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportOmrResponsesResponse {
    return new ImportOmrResponsesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportOmrResponsesResponse {
    return new ImportOmrResponsesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportOmrResponsesResponse | PlainMessage<ImportOmrResponsesResponse> | undefined, b: ImportOmrResponsesResponse | PlainMessage<ImportOmrResponsesResponse> | undefined): boolean {
    return proto3.util.equals(ImportOmrResponsesResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.OmrResponseRecord
 */
export class OmrResponseRecord extends Message<OmrResponseRecord> {
  /**
   * @generated from field: string date_of_assessment = 1;
   */
  dateOfAssessment = "";

  /**
   * @generated from field: string school_name = 2;
   */
  schoolName = "";

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * @generated from field: int64 assessment_id = 4;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string roll_number = 5;
   */
  rollNumber = "";

  /**
   * @generated from field: string student_name = 6;
   */
  studentName = "";

  /**
   * @generated from field: int32 class = 7;
   */
  class = 0;

  /**
   * @generated from field: string section = 8;
   */
  section = "";

  /**
   * @generated from field: string subject = 9;
   */
  subject = "";

  /**
   * @generated from field: int32 question_number = 10;
   */
  questionNumber = 0;

  /**
   * @generated from field: string student_answer_given = 11;
   */
  studentAnswerGiven = "";

  constructor(data?: PartialMessage<OmrResponseRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.OmrResponseRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date_of_assessment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "school_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "class", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "question_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "student_answer_given", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OmrResponseRecord {
    return new OmrResponseRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OmrResponseRecord {
    return new OmrResponseRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OmrResponseRecord {
    return new OmrResponseRecord().fromJsonString(jsonString, options);
  }

  static equals(a: OmrResponseRecord | PlainMessage<OmrResponseRecord> | undefined, b: OmrResponseRecord | PlainMessage<OmrResponseRecord> | undefined): boolean {
    return proto3.util.equals(OmrResponseRecord, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.InsertOmrResponsesRequest
 */
export class InsertOmrResponsesRequest extends Message<InsertOmrResponsesRequest> {
  /**
   * @generated from field: repeated geneo.analysis.school.assessment.apis.OmrResponseRecord responses = 1;
   */
  responses: OmrResponseRecord[] = [];

  constructor(data?: PartialMessage<InsertOmrResponsesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.InsertOmrResponsesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "responses", kind: "message", T: OmrResponseRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertOmrResponsesRequest {
    return new InsertOmrResponsesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertOmrResponsesRequest {
    return new InsertOmrResponsesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertOmrResponsesRequest {
    return new InsertOmrResponsesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InsertOmrResponsesRequest | PlainMessage<InsertOmrResponsesRequest> | undefined, b: InsertOmrResponsesRequest | PlainMessage<InsertOmrResponsesRequest> | undefined): boolean {
    return proto3.util.equals(InsertOmrResponsesRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.InsertOmrResponsesData
 */
export class InsertOmrResponsesData extends Message<InsertOmrResponsesData> {
  /**
   * @generated from field: int32 inserted = 1;
   */
  inserted = 0;

  /**
   * @generated from field: int32 failed = 2;
   */
  failed = 0;

  /**
   * @generated from field: repeated string errors = 3;
   */
  errors: string[] = [];

  constructor(data?: PartialMessage<InsertOmrResponsesData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.InsertOmrResponsesData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inserted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "failed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertOmrResponsesData {
    return new InsertOmrResponsesData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertOmrResponsesData {
    return new InsertOmrResponsesData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertOmrResponsesData {
    return new InsertOmrResponsesData().fromJsonString(jsonString, options);
  }

  static equals(a: InsertOmrResponsesData | PlainMessage<InsertOmrResponsesData> | undefined, b: InsertOmrResponsesData | PlainMessage<InsertOmrResponsesData> | undefined): boolean {
    return proto3.util.equals(InsertOmrResponsesData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.InsertOmrResponsesResponse
 */
export class InsertOmrResponsesResponse extends Message<InsertOmrResponsesResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.InsertOmrResponsesData data = 4;
   */
  data?: InsertOmrResponsesData;

  constructor(data?: PartialMessage<InsertOmrResponsesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.InsertOmrResponsesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: InsertOmrResponsesData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertOmrResponsesResponse {
    return new InsertOmrResponsesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertOmrResponsesResponse {
    return new InsertOmrResponsesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertOmrResponsesResponse {
    return new InsertOmrResponsesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InsertOmrResponsesResponse | PlainMessage<InsertOmrResponsesResponse> | undefined, b: InsertOmrResponsesResponse | PlainMessage<InsertOmrResponsesResponse> | undefined): boolean {
    return proto3.util.equals(InsertOmrResponsesResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportOverallData
 */
export class TeacherJeeAssessmentReportOverallData extends Message<TeacherJeeAssessmentReportOverallData> {
  /**
   * Test overview of the overall assessment
   *
   * @generated from field: geneo.analysis.school.assessment.apis.JeeReportTestOverview test_overview = 1;
   */
  testOverview?: JeeReportTestOverview;

  /**
   * Overall Students information
   *
   * @generated from field: repeated geneo.analysis.school.assessment.apis.JeeReportOverallStudent students = 2;
   */
  students: JeeReportOverallStudent[] = [];

  /**
   * List of recommendations
   *
   * @generated from field: repeated string recommendations = 3;
   */
  recommendations: string[] = [];

  constructor(data?: PartialMessage<TeacherJeeAssessmentReportOverallData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.TeacherJeeAssessmentReportOverallData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "test_overview", kind: "message", T: JeeReportTestOverview },
    { no: 2, name: "students", kind: "message", T: JeeReportOverallStudent, repeated: true },
    { no: 3, name: "recommendations", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherJeeAssessmentReportOverallData {
    return new TeacherJeeAssessmentReportOverallData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReportOverallData {
    return new TeacherJeeAssessmentReportOverallData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherJeeAssessmentReportOverallData {
    return new TeacherJeeAssessmentReportOverallData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherJeeAssessmentReportOverallData | PlainMessage<TeacherJeeAssessmentReportOverallData> | undefined, b: TeacherJeeAssessmentReportOverallData | PlainMessage<TeacherJeeAssessmentReportOverallData> | undefined): boolean {
    return proto3.util.equals(TeacherJeeAssessmentReportOverallData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.JeeReportOverallStudent
 */
export class JeeReportOverallStudent extends Message<JeeReportOverallStudent> {
  /**
   * Student name
   *
   * @generated from field: string student_name = 1;
   */
  studentName = "";

  /**
   * Student metrics
   *
   * @generated from field: geneo.analysis.school.assessment.apis.Metrics metrics = 2;
   */
  metrics?: Metrics;

  constructor(data?: PartialMessage<JeeReportOverallStudent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.JeeReportOverallStudent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metrics", kind: "message", T: Metrics },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): JeeReportOverallStudent {
    return new JeeReportOverallStudent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): JeeReportOverallStudent {
    return new JeeReportOverallStudent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): JeeReportOverallStudent {
    return new JeeReportOverallStudent().fromJsonString(jsonString, options);
  }

  static equals(a: JeeReportOverallStudent | PlainMessage<JeeReportOverallStudent> | undefined, b: JeeReportOverallStudent | PlainMessage<JeeReportOverallStudent> | undefined): boolean {
    return proto3.util.equals(JeeReportOverallStudent, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchOmrStudentAssessmentReportRequest
 */
export class FetchOmrStudentAssessmentReportRequest extends Message<FetchOmrStudentAssessmentReportRequest> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int32 assessment_id = 1;
   */
  assessmentId = 0;

  /**
   * ID for the student
   *
   * @generated from field: string student_id = 2;
   */
  studentId = "";

  constructor(data?: PartialMessage<FetchOmrStudentAssessmentReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchOmrStudentAssessmentReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchOmrStudentAssessmentReportRequest {
    return new FetchOmrStudentAssessmentReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchOmrStudentAssessmentReportRequest {
    return new FetchOmrStudentAssessmentReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchOmrStudentAssessmentReportRequest {
    return new FetchOmrStudentAssessmentReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchOmrStudentAssessmentReportRequest | PlainMessage<FetchOmrStudentAssessmentReportRequest> | undefined, b: FetchOmrStudentAssessmentReportRequest | PlainMessage<FetchOmrStudentAssessmentReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchOmrStudentAssessmentReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchOmrStudentAssessmentReportResponse
 */
export class FetchOmrStudentAssessmentReportResponse extends Message<FetchOmrStudentAssessmentReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.analysis.school.assessment.apis.StudentAssessmentReportDataObject data = 4;
   */
  data?: StudentAssessmentReportDataObject;

  constructor(data?: PartialMessage<FetchOmrStudentAssessmentReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchOmrStudentAssessmentReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentAssessmentReportDataObject },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchOmrStudentAssessmentReportResponse {
    return new FetchOmrStudentAssessmentReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchOmrStudentAssessmentReportResponse {
    return new FetchOmrStudentAssessmentReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchOmrStudentAssessmentReportResponse {
    return new FetchOmrStudentAssessmentReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchOmrStudentAssessmentReportResponse | PlainMessage<FetchOmrStudentAssessmentReportResponse> | undefined, b: FetchOmrStudentAssessmentReportResponse | PlainMessage<FetchOmrStudentAssessmentReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchOmrStudentAssessmentReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportV3Request
 */
export class FetchStudentsBulkAssessmentReportV3Request extends Message<FetchStudentsBulkAssessmentReportV3Request> {
  /**
   * ID for the Assessment
   *
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: bool is_summary_report = 2;
   */
  isSummaryReport = false;

  /**
   * @generated from field: optional int32 attempt_number = 3;
   */
  attemptNumber?: number;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 4;
   */
  attemptType?: AttemptTypeEnum;

  constructor(data?: PartialMessage<FetchStudentsBulkAssessmentReportV3Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportV3Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "is_summary_report", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "attempt_number", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 4, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentsBulkAssessmentReportV3Request {
    return new FetchStudentsBulkAssessmentReportV3Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportV3Request {
    return new FetchStudentsBulkAssessmentReportV3Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportV3Request {
    return new FetchStudentsBulkAssessmentReportV3Request().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentsBulkAssessmentReportV3Request | PlainMessage<FetchStudentsBulkAssessmentReportV3Request> | undefined, b: FetchStudentsBulkAssessmentReportV3Request | PlainMessage<FetchStudentsBulkAssessmentReportV3Request> | undefined): boolean {
    return proto3.util.equals(FetchStudentsBulkAssessmentReportV3Request, a, b);
  }
}

/**
 * @generated from message geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportV3Response
 */
export class FetchStudentsBulkAssessmentReportV3Response extends Message<FetchStudentsBulkAssessmentReportV3Response> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * data (required)
   *
   * @generated from field: geneo.analysis.school.assessment.apis.StudentsAssessmentBulkReportData data = 4;
   */
  data?: StudentsAssessmentBulkReportData;

  constructor(data?: PartialMessage<FetchStudentsBulkAssessmentReportV3Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.school.assessment.apis.FetchStudentsBulkAssessmentReportV3Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: StudentsAssessmentBulkReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchStudentsBulkAssessmentReportV3Response {
    return new FetchStudentsBulkAssessmentReportV3Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportV3Response {
    return new FetchStudentsBulkAssessmentReportV3Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchStudentsBulkAssessmentReportV3Response {
    return new FetchStudentsBulkAssessmentReportV3Response().fromJsonString(jsonString, options);
  }

  static equals(a: FetchStudentsBulkAssessmentReportV3Response | PlainMessage<FetchStudentsBulkAssessmentReportV3Response> | undefined, b: FetchStudentsBulkAssessmentReportV3Response | PlainMessage<FetchStudentsBulkAssessmentReportV3Response> | undefined): boolean {
    return proto3.util.equals(FetchStudentsBulkAssessmentReportV3Response, a, b);
  }
}

